module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_c('header', {
    staticClass: "site-header header-one home-page-one"
  }, [_c('nav', {
    staticClass: "navbar navbar-expand-lg navbar-light header-navigation stricky",
    staticStyle: {
      "background": "none"
    }
  }, [_c('div', {
    staticClass: "container clearfix nav-head",
    staticStyle: {
      "background": "none"
    }
  }, [_vm._m(0), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "right-side-box"
  }, [_c('a', {
    staticClass: "header-btn",
    attrs: {
      "href": '/' + _vm.sellpoint.business_username
    }
  }, [_vm._v("View Gallery")])]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "vtd vtd-right-side-box"
  }, [_c('a', {
    staticClass: "header-btn vtd-btn",
    attrs: {
      "href": '/' + _vm.sellpoint.business_username
    }
  }, [_vm._v("View Gallery")])]) : _vm._e()])])]), _vm._v(" "), _c('section', {
    staticStyle: {
      "height": "3em",
      "background": "#ffffff"
    },
    attrs: {
      "id": "top"
    }
  }, [_c('div', {
    staticClass: "container banner-menu"
  }, [_c('div', {
    staticClass: "row menu-links"
  }, [_c('ul', [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuComponent('lookbooks')
      }
    }
  }, [_vm._v("Lookbooks")])]), _vm._v(" "), _c('li', {
    staticClass: "gw-mobile"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuComponent('feeds')
      }
    }
  }, [_vm._v("Feeds")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuComponent('profile')
      }
    }
  }, [_vm._v("Profile")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuComponent('settings')
      }
    }
  }, [_vm._v("Orders")])]), _vm._v(" "), (!_vm.loading) ? _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setComponent('manage-panel')
      }
    }
  }, [_vm._v("Manage Gallery")])]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('li', [_c('a', {
    attrs: {
      "href": "/getstarted"
    }
  }, [_vm._v("Get a Mall Space")])]) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuComponent('settings')
      }
    }
  }, [_vm._v("Settings")])])])])])]), _vm._v(" "), (!_vm.setPanel) ? _c('section', {
    staticClass: "account-inner",
    staticStyle: {
      "background": "#f7fbff",
      "margin-top": "2em"
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "container"
  }, [_vm._m(1)]) : _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row account-inner-row"
  }, [_c('div', {
    staticClass: "col-md-4 col-sm-12"
  }, [_c('div', {
    staticClass: "info-card",
    attrs: {
      "id": "profile"
    }
  }, [_c('div', {
    staticClass: "info-card-header"
  }, [_c('div', {
    staticClass: "info-card-left"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-left": "5px"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "inherit"
    },
    attrs: {
      "href": '/' + _vm.sellpoint.business_username
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.sellpoint.business_name))]), _vm._v(" "), _c('p', {
    staticClass: "sp-form-descr",
    staticStyle: {
      "color": "inherit",
      "margin-top": "-1em"
    }
  }, [_vm._v("@" + _vm._s(_vm.sellpoint.business_username))])])])]), _vm._v(" "), _c('div', {
    staticClass: "info-card-right",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "inherit"
    },
    on: {
      "click": function($event) {
        _vm.toggleSwitchBusiness()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-cog"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "show-business-list",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "businessList"
    }
  }, _vm._l((_vm.sellpoints), function(sellpoint) {
    return _c('li', [_c('a', {
      staticStyle: {
        "cursor": "pointer",
        "color": "inherit"
      },
      on: {
        "click": function($event) {
          _vm.switchBusiness(sellpoint)
        }
      }
    }, [_vm._v(_vm._s(sellpoint.business_name))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "container info-card-body"
  }, [_c('div', {
    staticClass: "row info-stats-top"
  }, [_c('div', {
    staticClass: "col-xs-2 stats-block"
  }, [_c('h5', {
    staticClass: "stats-num"
  }, [_vm._v(_vm._s(_vm.sellpoint.business_total_gallery_posts))]), _vm._v(" "), _c('p', {
    staticClass: "stats-descr"
  }, [_vm._v("Posts")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2 stats-block stats-block-center"
  }, [_c('h5', {
    staticClass: "stats-num"
  }, [_vm._v(_vm._s(_vm.sellpoint.business_total_gallery))]), _vm._v(" "), _c('p', {
    staticClass: "stats-descr"
  }, [_vm._v("Lookbooks")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2 stats-block"
  }, [_c('h5', {
    staticClass: "stats-num"
  }, [_vm._v(_vm._s(_vm.sellpoint.business_total_views))]), _vm._v(" "), _c('p', {
    staticClass: "stats-descr"
  }, [_vm._v("Views")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row info-stats-list"
  }, [_c('p', [_c('span', [_vm._v("Category")]), _vm._v(_vm._s(_vm.sellpoint.business_category))])]), _vm._v(" "), _c('div', {
    staticClass: "row info-stats-list"
  }, [_c('p', [_c('span', [_vm._v("Tagline:")]), _vm._v(_vm._s(_vm.sellpoint.business_tagline))])]), _vm._v(" "), _c('div', {
    staticClass: "row info-stats-list"
  }, [_c('p', [_c('span', [_vm._v("Brief:")]), _vm._v(_vm._s(_vm.sellpoint.business_profile))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('a', {
    staticClass: "btn vtd-btn",
    staticStyle: {
      "float": "left",
      "background": "#f1dee4",
      "font-size": "14px"
    },
    attrs: {
      "href": '/' + _vm.sellpoint.business_username
    }
  }, [_vm._v("View Gallery")]), _vm._v(" "), _c('button', {
    staticClass: "btn vtd-btn",
    staticStyle: {
      "float": "right",
      "background": "#f1dee4",
      "font-size": "14px"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('manage-panel', '')
      }
    }
  }, [_vm._v("Manage Gallery")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-12",
    attrs: {
      "id": "lookbooks"
    }
  }, [_c('div', {
    staticClass: "info-card"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "container info-card-body"
  }, [_c('div', {
    staticClass: "row info-card-row"
  }, [_c('div', {
    staticClass: "col-12 col-sm-12 col-xs-12 col-md-6 offset-md-4"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e()]), _vm._v(" "), _vm._l((_vm.galleria), function(gallery, gndex) {
    return _c('div', {
      staticClass: "col-sm-12"
    }, [_c('div', {
      staticClass: "container"
    }, [_c('div', {
      staticClass: "row",
      staticStyle: {
        "font-size": "12px",
        "line-height": "1.2"
      }
    }, [_c('div', {
      staticClass: "col-sm-3"
    }, [(gallery.gallery_posts_group_posts_media.length > 0) ? _c('div', {
      staticStyle: {
        "margin": "5px"
      }
    }, [(_vm.checkIfVideo(gallery.gallery_posts_group_posts_media[0].gallery_post_media)) ? _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": "/static/assets/images/video-placeholder.png"
      }
    }) : _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": gallery.gallery_posts_group_posts_media[0].gallery_post_media
      }
    })]) : _c('div', {
      staticStyle: {
        "margin": "5px"
      }
    }, [_c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": "/static/assets/images/dummy-image.png",
        "alt": ""
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-3"
    }, [_c('p', [_vm._v(_vm._s(gallery.gallery_posts_group_name))])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-2"
    }, [_c('p', [_vm._v(_vm._s(gallery.gallery_posts_group_posts.length) + " posts")])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-2"
    })])])])
  }), _vm._v(" "), (_vm.galleria.length == 0) ? _c('div', {
    staticStyle: {
      "margin": "1em"
    }
  }, [_vm._m(4)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-12",
    attrs: {
      "id": "feeds"
    }
  }, [_c('div', {
    staticClass: "info-card info-card-feeds"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "container info-card-body"
  }, [_c('div', {
    staticClass: "row info-card-inner-row"
  }, [(_vm.sellpoint.business_notifications && (_vm.sellpoint.business_notifications.length != 0)) ? _c('div', {
    staticClass: "notification-slide"
  }, [_c('div', {
    staticClass: "pc-slider"
  }, [_c('input', {
    staticClass: "input-slide input-slide-num",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "name": "input-slider",
      "id": "input-slide-0",
      "type": "radio"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "input-slide input-slide-num",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "name": "input-slider",
      "id": "input-slide-1",
      "type": "radio"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "input-slide input-slide-num",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "name": "input-slider",
      "id": "input-slide-2",
      "type": "radio"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "input-slide input-slide-num",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "name": "input-slider",
      "id": "input-slide-3",
      "type": "radio"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "input-slide",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "name": "input-slider",
      "id": "input-slide-autoplay",
      "type": "radio",
      "checked": ""
    }
  }), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "slide-description"
  }, [_c('label', {
    staticClass: "slide-0"
  }, [_c('p', {
    staticClass: "text-slide"
  }, [_vm._v(_vm._s(_vm.sellpoint.business_notifications[0].notification_message))])]), _vm._v(" "), _c('label', {
    staticClass: "slide-1"
  }, [_c('p', {
    staticClass: "text-slide"
  }, [_vm._v(_vm._s(_vm.sellpoint.business_notifications[1].notification_message))])]), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11)])]) : _c('div', [_vm._m(12)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-12",
    attrs: {
      "id": "contact"
    }
  }, [_c('div', {
    staticClass: "info-card"
  }, [_vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "container info-card-body"
  }, [_c('div', {
    staticClass: "row info-card-inner-row info-stats-list"
  }, [_c('p', [_c('span', [_vm._v("Address")]), _vm._v(_vm._s(_vm.sellpoint.business_address))])]), _vm._v(" "), _c('div', {
    staticClass: "row info-card-inner-row info-stats-list"
  }, [_c('p', [_c('span', [_vm._v("Email:")]), _vm._v(_vm._s(_vm.sellpoint.business_emails))])]), _vm._v(" "), _c('div', {
    staticClass: "row info-card-inner-row info-stats-list"
  }, [_c('p', [_c('span', [_vm._v("Phone:")]), _vm._v(_vm._s(_vm.sellpoint.business_phones))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-12",
    attrs: {
      "id": "subscription"
    }
  }, [_c('div', {
    staticClass: "info-card"
  }, [_vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "container info-card-body",
    staticStyle: {
      "padding": "0 1em"
    }
  }, [_c('p', [_c('b', [_vm._v("Current Plan: ")]), _c('span', {
    staticStyle: {
      "color": "#ff0055",
      "font-weight": "500"
    }
  }, [_vm._v(_vm._s(_vm.sellpoint_gallery.business_market_subscription_name))])]), _vm._v(" "), (!_vm.can_add_more_lookbook) ? _c('div', [_c('div', {
    staticClass: "col-md-12 col-sm-12",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [_c('div', {
    staticClass: "manage-action-block"
  }, [_c('h5', [_vm._v("You have reached the limit of your gallery")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "inherit"
    }
  }, [_c('p', [_vm._v("To add more lookbooks to your gallery, "), _c('a', {
    staticClass: "btn",
    staticStyle: {
      "background": "#ff0055",
      "color": "#ffffff"
    },
    attrs: {
      "href": '/purchase?upgrade=' + _vm.sellpoint.business_username
    }
  }, [_vm._v("Upgrade your Account")])])])])])]) : _vm._e(), _vm._v(" "), (!_vm.can_add_product_lookbook) ? _c('div', [_c('div', {
    staticClass: "col-md-12 col-sm-12",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [_c('div', {
    staticClass: "manage-action-block"
  }, [_c('h5', [_vm._v("Do you want to sell some Products or Services of your Gallery? ")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "inherit"
    }
  }, [_c('p', [_vm._v("Unlock this Package. "), _c('a', {
    staticClass: "btn",
    staticStyle: {
      "background": "#ff0055",
      "color": "#ffffff"
    },
    attrs: {
      "href": '/purchase?upgrade=' + _vm.sellpoint.business_username
    }
  }, [_vm._v("Upgrade your Account to Unlock")])])])])])]) : _vm._e(), _vm._v(" "), (_vm.can_add_more_lookbook && _vm.can_add_product_lookbook) ? _c('div', [_vm._m(15)]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-12",
    attrs: {
      "id": "settings"
    }
  }, [_c('div', {
    staticClass: "info-card info-card-feeds"
  }, [_vm._m(16), _vm._v(" "), (_vm.setSettings) ? _c('div', {
    staticClass: "container"
  }, [(_vm.setting_details.editProfile) ? _c('div', [_c('h6', [_vm._v("Edit Profile Details")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', [_vm._v("Name\r\n                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_name),
      expression: "user.user_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.user_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', [_vm._v("Phone Number\r\n                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_phone),
      expression: "user.user_phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.user_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_phone = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn",
    staticStyle: {
      "line-height": "1.6",
      "font-size": "12px"
    },
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": _vm.editProfileDetails
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])])]) : _vm._e()]) : _c('div', {
    staticClass: "container info-card-body"
  }, [_vm._m(17), _vm._v(" "), _c('div', {
    staticClass: "row info-card-inner-row"
  }, [_c('a', {
    staticClass: "btn",
    staticStyle: {
      "cursor": "pointer",
      "background": "#f1dee4",
      "padding": "1em",
      "color": "#000"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('set-settings-inner', 'editProfile')
      }
    }
  }, [_vm._v("Edit Profile")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row info-card-inner-row",
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    staticClass: "btn",
    staticStyle: {
      "cursor": "pointer",
      "background": "#f1dee4",
      "padding": "1em",
      "color": "#000"
    },
    on: {
      "click": function($event) {
        _vm.syncset(_vm.sellpoint.business_username)
      }
    }
  }, [_vm._v("Manage Account on Sellpoint")])])])])])]), _vm._v(" "), _vm._m(18)])]) : _vm._e(), _vm._v(" "), (_vm.managePanel) ? _c('section', {
    staticClass: "account-inner-set-panel",
    staticStyle: {
      "background": "#f7fbff",
      "margin-top": "2em"
    },
    attrs: {
      "id": "manage"
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "container"
  }, [_vm._m(19)]) : _c('div', {
    staticClass: "container",
    staticStyle: {
      "background": "#ffffff",
      "margin-top": "1em",
      "padding": "1em"
    }
  }, [_c('h5', [_vm._v("Manage Gallery")]), _vm._v(" "), _c('div', {
    staticClass: "container banner-menu manage-account-menu"
  }, [_c('div', {
    staticClass: "row menu-links"
  }, [_c('ul', [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setComponent('manage-businesses', '')
      }
    }
  }, [_vm._v("Business Settings")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setComponent('manage-lookbooks', '')
      }
    }
  }, [_vm._v("Lookbooks Settings")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setComponent('manage-products', '')
      }
    }
  }, [_vm._v("Products")])])])])]), _vm._v(" "), (_vm.manageBusinesses) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row card-row-controls"
  }, [_c('div', [(_vm.manageBusinessDetails) ? _c('button', {
    staticClass: "btn admin-btn",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-component-details', '')
      }
    }
  }, [_vm._v("Back")]) : _vm._e()])]), _vm._v(" "), (!_vm.manageBusinessDetails) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "row cards-grids"
  }, [_c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-6",
    attrs: {
      "id": "businessprofile"
    }
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('set-business-card-details', 0)
      }
    }
  }, [_vm._m(20)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-6",
    attrs: {
      "id": "businessprofile"
    }
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('set-business-card-details', 1)
      }
    }
  }, [_vm._m(21)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-6",
    attrs: {
      "id": "businessprofile"
    }
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('set-business-card-details', 2)
      }
    }
  }, [_vm._m(22)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-6",
    attrs: {
      "id": "businessprofile"
    }
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('set-business-card-details', 3)
      }
    }
  }, [_vm._m(23)])])])]) : _c('div', {
    staticClass: "row"
  }, [(_vm.businessComponents[0]) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 col-xs-12 col-md-8 offset-md-1 set-panel"
  }, [_c('div', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('h4', [_vm._v("Edit Business Details")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('form', {
    staticClass: "gw-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Business Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_name),
      expression: "sellpoint.business_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Business Tagline")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_tagline),
      expression: "sellpoint.business_tagline"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_tagline)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_tagline = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Business Brief")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_profile),
      expression: "sellpoint.business_profile"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.sellpoint.business_profile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_profile = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Business Address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_address),
      expression: "sellpoint.business_address"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_address = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Business Emails")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_emails),
      expression: "sellpoint.business_emails"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_emails)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_emails = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Business Phone")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_phones),
      expression: "sellpoint.business_phones"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_phones)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_phones = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#4617c7"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn",
    staticStyle: {
      "float": "left",
      "background": "#f1dee4"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.editBusinessDetails('main')
      }
    }
  }, [_vm._v("Save Details")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    staticStyle: {
      "float": "right",
      "background": "#ecb989"
    },
    on: {
      "click": function($event) {
        _vm.reset()
      }
    }
  }, [_vm._v("Cancel")])])])])])]) : _vm._e(), _vm._v(" "), (_vm.businessComponents[1]) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 col-xs-12 col-md-10  set-panel"
  }, [_c('div', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "horizontal-cards"
  }, [_vm._m(24), _vm._v(" "), (_vm.business_details.delivery_edit) ? _c('div', {
    staticClass: "contact_form"
  }, [_c('label', [_vm._v("Your Delivery Information")]), _c('br'), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_delivery_information),
      expression: "sellpoint.business_delivery_information"
    }],
    staticStyle: {
      "width": "70%"
    },
    domProps: {
      "value": (_vm.sellpoint.business_delivery_information)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_delivery_information = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.editBusinessDetails('delivery')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v("save")]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" cancel")])]) : _c('div', [(_vm.sellpoint.business_delivery_information) ? _c('p', [_vm._v(_vm._s(_vm.sellpoint.business_delivery_information) + "\r\n                            "), _c('button', {
    staticClass: "btn admin-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('set-business-details', 'delivery_edit')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  }), _vm._v("edit")]), _vm._v(" "), _c('br')]) : _c('p', [_vm._v("You have not set any delivery information\r\n                            "), _c('button', {
    staticClass: "btn admin-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('set-business-details', 'delivery_edit')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  }), _vm._v("Set")]), _vm._v(" "), _c('br')])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "horizontal-cards"
  }, [_c('h6', {
    staticClass: "margin-t-40"
  }, [_vm._v("Set How Shipping Fee would affect Buyers Checkout Ordering")]), _vm._v(" "), _c('p', [_vm._v("This setting affects all products orders shipping fees on th this Business. If you would like any product \r\n                            to have its on shipping fee, specify it when setting up your product.\r\n                        ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#363535"
    }
  }, [_vm._v("How would your Business Shipping Fee be calculated?")]), _vm._v(" "), _c('span', [_c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business_set_shipping_fee_status),
      expression: "business_set_shipping_fee_status"
    }],
    attrs: {
      "type": "radio",
      "id": "9",
      "value": "9"
    },
    domProps: {
      "checked": _vm._q(_vm.business_set_shipping_fee_status, "9")
    },
    on: {
      "click": function($event) {
        _vm.setShippingFeeStatus()
      },
      "__c": function($event) {
        _vm.business_set_shipping_fee_status = "9"
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(" One Charge Business Shipping Fee on all Items Ordered")])])]), _vm._v(" "), _c('span', [_c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business_set_shipping_fee_status),
      expression: "business_set_shipping_fee_status"
    }],
    attrs: {
      "type": "radio",
      "id": "10",
      "value": "10"
    },
    domProps: {
      "checked": _vm._q(_vm.business_set_shipping_fee_status, "10")
    },
    on: {
      "click": function($event) {
        _vm.setShippingFeeStatus()
      },
      "__c": function($event) {
        _vm.business_set_shipping_fee_status = "10"
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(" Same Charge Business Shipping Fee on each Product Ordered")])])]), _vm._v(" "), _c('span', [_c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business_set_shipping_fee_status),
      expression: "business_set_shipping_fee_status"
    }],
    attrs: {
      "type": "radio",
      "id": "11",
      "value": "11"
    },
    domProps: {
      "checked": _vm._q(_vm.business_set_shipping_fee_status, "11")
    },
    on: {
      "click": function($event) {
        _vm.setShippingFeeStatus()
      },
      "__c": function($event) {
        _vm.business_set_shipping_fee_status = "11"
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Same Charge Business Shipping Fee on each Product and its quantities Ordered")])])]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('br')]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_c('h6', [_vm._v("Delivery Locations and Prices")]), _vm._v(" "), _c('div', [_c('div', [_vm._l((_vm.sellpoint.business_delivery_options), function(delivery_option) {
    return _c('div', [(_vm.business_details.delivery_option_edit && delivery_option.edit_set) ? _c('div', {
      staticClass: "contact_form"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("State")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (delivery_option.business_delivery_state),
        expression: "delivery_option.business_delivery_state"
      }],
      staticClass: "form-control",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          delivery_option.business_delivery_state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.getCities(delivery_option.business_delivery_state, 'edit')
        }]
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select State")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
      return _c('option', {
        domProps: {
          "value": state.state_id
        }
      }, [_vm._v(_vm._s(state.name))])
    })], 2)]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("City: "), _c('b', [_vm._v(_vm._s(delivery_option.business_delivery_option))])]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (delivery_option.city),
        expression: "delivery_option.city"
      }],
      staticClass: "form-control",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          delivery_option.city = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.setOtherOptions(delivery_option.city, 'edit')
        }]
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select City")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "all"
      }
    }, [_vm._v("All Areas @Fixed Price")]), _vm._v(" "), _vm._l((_vm.cities), function(city) {
      return _c('option', {
        domProps: {
          "value": city.city_id
        }
      }, [_vm._v(_vm._s(city.city_name))])
    }), _vm._v(" "), _c('option', {
      attrs: {
        "value": "other"
      }
    }, [_vm._v("Other Areas / Cities ")])], 2)]), _vm._v(" "), (_vm.edit_other_delivery_option) ? _c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("Other Areas / Cities")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (delivery_option.business_delivery_other_option),
        expression: "delivery_option.business_delivery_other_option"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "eg. Abuja"
      },
      domProps: {
        "value": (delivery_option.business_delivery_other_option)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          delivery_option.business_delivery_other_option = $event.target.value
        }
      }
    }), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("Delivery Amount")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (delivery_option.business_delivery_option_price),
        expression: "delivery_option.business_delivery_option_price"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "required": ""
      },
      domProps: {
        "value": (delivery_option.business_delivery_option_price)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          delivery_option.business_delivery_option_price = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [(_vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
      staticClass: "btn admin-btn",
      staticStyle: {
        "line-height": "1.6",
        "padding": "10px"
      },
      attrs: {
        "disabled": _vm.disable_btn,
        "title": "save",
        "type": "submit"
      },
      on: {
        "click": _vm.editDeliveryOption
      }
    }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
      staticClass: "btn admin-btn",
      staticStyle: {
        "line-height": "1.6",
        "padding": "10px"
      },
      attrs: {
        "title": "cancel",
        "type": "submit"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_vm._v("Cancel")])])]) : _c('div', [(delivery_option.business_delivery_product == 0) ? _c('p', [_vm._v("\r\n                                    " + _vm._s(delivery_option.business_delivery_option) + " - " + _vm._s(delivery_option.business_delivery_option_price) + " \r\n                                    "), _c('button', {
      staticClass: "btn admin-btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('edit-delivery-option', delivery_option)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn admin-btn",
      attrs: {
        "disabled": _vm.disable_btn,
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.deleteDeliveryOption(delivery_option.business_delivery_option_id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])]) : _vm._e()])])
  }), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('set-business-details', 'delivery_add')
      }
    }
  }, [_vm._v("Add New Delivery Information")]), _vm._v(" "), _c('hr')], 2), _vm._v(" "), (_vm.business_details.delivery_add) ? _c('div', {
    staticClass: "contact_form col-md-12",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('h5', [_vm._v("Add a Delivery Location and Price")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("State")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.state),
      expression: "delivery_option.state"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.delivery_option.state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getCities(_vm.delivery_option.state, '')
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select State")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
    return _c('option', {
      domProps: {
        "value": state.state_id
      }
    }, [_vm._v(_vm._s(state.name))])
  })], 2)]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), (_vm.cities.length && _vm.cities.length != 0 && !_vm.edit_city) ? _c('div', [_c('label', [_vm._v("City")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.city),
      expression: "delivery_option.city"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.delivery_option.city = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.setOtherOptions(_vm.delivery_option.city, '')
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select City")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("All Areas @Fixed Price")]), _vm._v(" "), _vm._l((_vm.cities), function(city) {
    return _c('option', {
      domProps: {
        "value": city.city_id
      }
    }, [_vm._v(_vm._s(city.city_name))])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "other"
    }
  }, [_vm._v("Other Areas / Cities ")])], 2)]) : _vm._e(), _vm._v(" "), (_vm.other_delivery_option) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Other Areas / Cities")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.delivery_other_option),
      expression: "delivery_option.delivery_other_option"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "eg. Abuja"
    },
    domProps: {
      "value": (_vm.delivery_option.delivery_other_option)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.delivery_option.delivery_other_option = $event.target.value
      }
    }
  }), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Delivery Charge")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.delivery_option_price),
      expression: "delivery_option.delivery_option_price"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "eg. 1000"
    },
    domProps: {
      "value": (_vm.delivery_option.delivery_option_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.delivery_option.delivery_option_price = $event.target.value
      }
    }
  }), _c('br')]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn",
    staticStyle: {
      "line-height": "1.6",
      "font-size": "12px"
    },
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": _vm.addDeliveryOption
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])]) : _vm._e()]), _vm._v(" "), _c('div')])])])])]) : _vm._e(), _vm._v(" "), (_vm.businessComponents[2]) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 col-xs-12 col-md-10  set-panel"
  }, [_c('div', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', {}, [_c('div', {
    staticClass: "horizontal-cards"
  }, [_c('h6', {
    staticClass: "margin-t-40"
  }, [_vm._v("Set My Sellpoint's Discounts and Coupons")]), _vm._v(" "), _c('p', [_vm._v("Set a general discount and coupons that would apply to all products and services in your sellpoint. \r\n                          You can set individual Product Discounts on thier product pages.\r\n                      ")]), _vm._v(" "), _c('span', [(_vm.business_details.setDiscount) ? _c('button', {
    staticClass: "btn admin-btn",
    on: {
      "click": function($event) {
        _vm.setComponent('view-discounts', '')
      }
    }
  }, [_vm._v("View your Discounts")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn",
    on: {
      "click": function($event) {
        _vm.setComponent('set-business-details', 'setDiscount')
      }
    }
  }, [_vm._v("Set New Discount Or Coupon")]), _vm._v(" "), _c('br'), _c('br')]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.business_details.setDiscount) ? _c('div', [_c('div', {
    staticClass: "contact-form col-md-6",
    staticStyle: {
      "padding-left": "0"
    }
  }, [(_vm.sellpoint.business_discounts_active == 1) ? _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("You have an ongoing active Discount")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Set Coupon Or Discount")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.is_discount_coupon),
      expression: "discount_coupon.is_discount_coupon"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.discount_coupon.is_discount_coupon = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "D"
    }
  }, [_vm._v("Discount")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "C"
    }
  }, [_vm._v("Coupon")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label'), _vm._v(" "), (_vm.sellpoint.business_discounts_active != 1) ? _c('label', [_vm._v("Select Discount Category")]) : _c('label', [_vm._v("Select Coupon Discount Category")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_category),
      expression: "discount_coupon.discount_category"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.discount_coupon.discount_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select Category")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("All Categories")]), _vm._v(" "), _vm._l((_vm.sellpoint.business_categories), function(cat) {
    return _c('option', {
      domProps: {
        "value": cat.business_category_id
      }
    }, [_vm._v(_vm._s(cat.business_category))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Percentage Discount")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_percentage),
      expression: "discount_coupon.discount_percentage"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "100"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_percentage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_percentage = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Start Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_start_date),
      expression: "discount_coupon.discount_start_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_start_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("End Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_end_date),
      expression: "discount_coupon.discount_end_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_end_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_end_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn",
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.setDiscountsAndCoupons()
      }
    }
  }, [_vm._v("SET")]), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn",
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])])]), _vm._v(" "), _vm._m(25)]) : _vm._e(), _vm._v(" "), (_vm.discount_coupon.edit && (!_vm.business_details.viewDiscounts || !_vm.business_details.setDiscount)) ? _c('div', [_c('h5', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("Edit Discount")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_category),
      expression: "discount_coupon.discount_category"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.discount_coupon.discount_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select Another Category")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("All Categories")]), _vm._v(" "), _vm._l((_vm.sellpoint.business_categories), function(cat) {
    return _c('option', {
      domProps: {
        "value": cat.business_category_id
      }
    }, [_vm._v(_vm._s(cat.business_category))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Percentage Discount")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_percentage),
      expression: "discount_coupon.discount_percentage"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "100"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_percentage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_percentage = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Start Date: " + _vm._s(_vm.discount_coupon.discount_start_date))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_start_date),
      expression: "discount_coupon.discount_start_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_start_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("End Date: " + _vm._s(_vm.discount_coupon.discount_end_date))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_end_date),
      expression: "discount_coupon.discount_end_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_end_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_end_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn",
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.editDiscountsAndCoupons()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn",
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])])])]) : _vm._e(), _vm._v(" "), ((!_vm.business_details.setDiscount && !_vm.discount_coupon.edit) && _vm.sellpoint.business_discounts_coupons) ? _c('div', [_c('h5', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("View Discounts")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.sellpoint.business_discounts_coupons), function(dc, index) {
    return _c('div', {
      staticClass: "col-md-4 col-xs-12"
    }, [_c('div', {
      staticStyle: {
        "border": "#f1dee4 solid 1px",
        "padding": "1em"
      }
    }, [_c('div', {
      staticStyle: {
        "background": "#d1ddf1",
        "text-align": "center"
      }
    }, [(dc.discount_coupon == 'D') ? _c('p', [_c('b', [_vm._v("Discount")])]) : _vm._e(), _vm._v(" "), (dc.discount_coupon == 'C') ? _c('p', [_c('b', [_vm._v("Coupon:")]), _vm._v(" (Code: " + _vm._s(dc.discount_coupon_code) + " )")]) : _vm._e()]), _vm._v(" "), ((dc.discount_type == 4) || (dc.discount_type == 5)) ? _c('p', [_c('b', [_vm._v("Type: ")]), _vm._v(_vm._s(dc.discount_type_name))]) : _c('p', [_c('b', [_vm._v("Type: ")]), _vm._v(_vm._s(dc.discount_category_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("%Discount: ")]), _vm._v(_vm._s(dc.discount_percentage) + "%")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Start Date: ")]), _vm._v(_vm._s(dc.discount_start_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("End Date: ")]), _vm._v(_vm._s(dc.discount_end_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Status: ")]), _vm._v(_vm._s(dc.discount_status))]), _vm._v(" "), ((dc.discount_type == 2) || (dc.discount_type == 3)) ? _c('div', [(dc.discount_status_id == 5) ? _c('p', [_c('a', {
      staticStyle: {
        "cursor": "pointer",
        "text-decoration": "underline",
        "font-size": "13px",
        "color": "#448aff"
      },
      attrs: {
        "title": "Edit"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('edit-discount-coupon', dc)
        }
      }
    }, [_vm._v("\r\n                                    Edit Coupon")]), _vm._v("    \r\n                                "), _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "text-decoration": "underline",
        "font-size": "13px",
        "color": "#448aff"
      },
      attrs: {
        "title": "De-Activate"
      },
      on: {
        "click": function($event) {
          _vm.deactivateDiscountsAndCoupons(dc)
        }
      }
    }, [_vm._v("\r\n                                    Deactivate Coupon")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), ((dc.discount_type == 4) || (dc.discount_type == 5)) ? _c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("Edit/Deactivate at Product Settings")]) : _vm._e()])])
  }))]) : _vm._e()])])])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.manageProducts) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('h6', {
    staticStyle: {
      "margin-left": "1em",
      "margin-right": "2em"
    }
  }, [_vm._v("Products (" + _vm._s(_vm.sellpoint.business_total_products) + ")")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), (_vm.component_view.viewProducts) ? _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.products), function(product, gndex) {
    return _c('div', {
      staticClass: "col-md-2 col-sm-3 col-xs-3"
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setComponentView('products', product, '')
        }
      }
    }, [_c('div', {
      staticClass: "info-card info-card-lookbook"
    }, [_c('div', {
      staticClass: "container info-card-body"
    }, [_c('div', {
      staticClass: "info-card-row info-card-lookbook-row"
    }, [_c('div', {}, [(product.product_images.length > 0) ? _c('div', {
      staticClass: "info-card-lookbook-image",
      staticStyle: {
        "margin": "5px"
      }
    }, [(_vm.checkIfVideo(product.product_images[0].product_image)) ? _c('img', {
      staticClass: "sp-prd-img-cs",
      attrs: {
        "src": "/static/assets/images/video-placeholder.png"
      }
    }) : _c('img', {
      staticClass: "sp-prd-img-cs",
      attrs: {
        "src": product.product_images[0].product_image
      }
    })]) : _c('div', {
      staticStyle: {
        "margin": "5px"
      }
    }, [_c('img', {
      staticClass: "sp-prd-img-cs",
      attrs: {
        "src": "/static/assets/images/dummy-image.png",
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticStyle: {
        "line-height": "0.8"
      }
    }, [_c('p', [_vm._v(_vm._s(product.product_name))])])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })])])])])])
  })) : _vm._e(), _vm._v(" "), (_vm.component_view.viewProduct) ? _c('div', {
    staticClass: "row col-md-12",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.is_viewing_lookbook) ? _c('div', [_c('button', {
    staticClass: "btn admin-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponentView('switch-to-viewing-loobook', '', '')
      }
    }
  }, [_vm._v("<< Back to Lookbook")])]) : _c('div', [_c('button', {
    staticClass: "btn admin-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponentView('products', '', '')
      }
    }
  }, [_vm._v("<< Back ")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', {
    staticClass: "col-md-5 col-xs-12"
  }, [_c('div', {
    staticClass: "product-detail-card"
  }, [_c('h4', [_vm._v(_vm._s(_vm.product.product_name))]), _vm._v(" "), _c('p', [_vm._v("Category: " + _vm._s(_vm.product.product_category_name))]), _vm._v(" "), (_vm.product.product_set_items == 0) ? _c('div', [(_vm.product.product_items[0].product_item_actual_price != 0) ? _c('div', [_c('p', [_vm._v("Price: ₦" + _vm._s(_vm.product.product_items[0].product_item_actual_price))]), _vm._v(" "), _c('p', [_vm._v("Discounted Price: ₦" + _vm._s(_vm.product.product_items[0].product_item_price))])]) : _c('div', [_c('p', [_vm._v("Price: ₦" + _vm._s(_vm.product.product_items[0].product_item_price))])]), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('p', [_vm._v("Weight: " + _vm._s(_vm.product.product_items[0].product_item_weight) + "(kg)")]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("Quantity: " + _vm._s(_vm.product.product_items[0].product_item_quantity))])]) : _vm._e(), _vm._v(" "), (_vm.product_details.editProductSingleProductItem) ? _c('div', {
    staticClass: "row col-md-12"
  }, [_c('h6', {
    staticStyle: {
      "font-size": "14px",
      "text-decoration": "underline"
    }
  }, [_vm._v("Reset Product Details")]), _vm._v(" "), _c('form', {
    staticClass: "sp-forms-one"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-4 col-xs-4"
  }, [_c('label', [_vm._v(" Price\r\n                          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_items[0].product_item_price),
      expression: "product.product_items[0].product_item_price"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.product.product_items[0].product_item_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_items[0].product_item_price = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('div', {
    staticClass: "form-group col-md-4 col-xs-4"
  }, [_c('label', [_vm._v(" Weight\r\n                          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_items[0].product_item_weight),
      expression: "product.product_items[0].product_item_weight"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.product.product_items[0].product_item_weight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_items[0].product_item_weight = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-4 col-xs-4"
  }, [_c('label', [_vm._v(" Quantity\r\n                          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_items[0].product_item_quantity),
      expression: "product.product_items[0].product_item_quantity"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.product.product_items[0].product_item_quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_items[0].product_item_quantity = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn col-md-2",
    staticStyle: {
      "line-height": "1.2",
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.editProductSingleProductItem
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn col-md-2",
    staticStyle: {
      "line-height": "1.2",
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Cancel")])])])])]) : _c('button', {
    staticClass: "btn btn-xs admin-btn-tiny",
    staticStyle: {
      "line-height": "0.8",
      "margin-bottom": "5px"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('editProductSingleProductItem', '')
      }
    }
  }, [_vm._v("Edit Price/Weight/Quantity")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.product.product_description))]), _vm._v(" "), (_vm.product_details.editProduct) ? _c('div', {
    staticClass: "row col-md-12"
  }, [_c('h6', [_vm._v("Edit Product")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('form', {
    staticClass: "sp-forms-one"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('label', [_vm._v(" *Product Name\r\n                                      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_name),
      expression: "product.product_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._v("Category:- " + _vm._s(_vm.product.product_category_name) + " ")]), _vm._v(" "), (_vm.sellpoint_categories.length > 0) ? _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', [_vm._v(" Select from My Shop Categories\r\n                                  "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_category),
      expression: "product.product_category"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "category-type-1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.product.product_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.trackevent('category-type-1')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "0",
      "disabled": _vm.category_type_1
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.sellpoint_categories), function(category) {
    return _c('option', {
      key: category.business_category_id,
      attrs: {
        "disabled": _vm.category_type_1
      },
      domProps: {
        "value": category.business_category_id
      }
    }, [_vm._v(_vm._s(category.business_category))])
  })], 2)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', [(_vm.sellpoint_categories.length > 0) ? _c('span', [_c('b', [_vm._v("Or ")])]) : _vm._e(), _vm._v(" Select from Related Categories\r\n                                  "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.main_category),
      expression: "main_category"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.main_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getSubCategories(_vm.main_category)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.categories), function(category) {
    return _c('option', {
      key: category.category_id,
      domProps: {
        "value": category
      }
    }, [_vm._v(_vm._s(category.category_name))])
  })], 2)]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.sub_categories.length != 0) ? _c('label', [_vm._v(" Select a Category\r\n                                  "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_sub_category),
      expression: "product.product_sub_category"
    }],
    staticClass: "form-control category-type-2",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.product.product_sub_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.trackevent('category-type-2')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "0",
      "disabled": _vm.category_type_2
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.sub_categories), function(category) {
    return _c('option', {
      key: category.sub_category_id,
      attrs: {
        "disabled": _vm.category_type_2
      },
      domProps: {
        "value": category.sub_category_id
      }
    }, [_vm._v(_vm._s(category.sub_category_name))])
  })], 2)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-8"
  }, [_c('label', [_c('b', [_vm._v("Or ")]), _vm._v(" Enter a specific Category\r\n                                  "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_listed_category),
      expression: "product.product_listed_category"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.category_type_3,
      "type": "text",
      "placeholder": "",
      "id": "category-type-3"
    },
    domProps: {
      "value": (_vm.product.product_listed_category)
    },
    on: {
      "change": function($event) {
        _vm.trackevent('category-type-3')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_listed_category = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', [_vm._v(" *Product Description\r\n                                  "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_description),
      expression: "product.product_description"
    }],
    staticClass: "form-control txtarea",
    domProps: {
      "value": (_vm.product.product_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_description = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn col-md-4",
    staticStyle: {
      "line-height": "1.2",
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.editProduct
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn col-md-4",
    staticStyle: {
      "line-height": "1.2",
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Cancel")])])])])]) : _c('button', {
    staticClass: "btn btn-xs admin-btn",
    staticStyle: {
      "line-height": "0.8",
      "margin-bottom": "5px"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('editProduct', '')
      }
    }
  }, [_vm._v("Edit Product Details")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h6', [_vm._v("Product Images")]), _vm._v(" "), _c('div', {
    staticClass: "img-row",
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_vm._l((_vm.product.product_images), function(pt) {
    return _c('div', {
      staticClass: "img-column"
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer",
        "float": "left"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('set-product-item', pt)
        }
      }
    }, [_c('img', {
      staticClass: "sp-prd-img",
      staticStyle: {
        "height": "50px",
        "width": "80px"
      },
      attrs: {
        "src": _vm.img_product_url + pt.product_image,
        "alt": ""
      }
    })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
      staticClass: "btn pull-right",
      staticStyle: {
        "margin-top": "-3em",
        "font-size": "10px",
        "padding": "6px",
        "float": "right"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.deleteProductImage(pt.product_image_id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [(_vm.action_loading && _vm.product_details.uploading_image) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "upload-btn",
    staticStyle: {
      "line-height": "0.6",
      "font-size": "12px"
    }
  }, [_vm._v("Add new Photo")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event, 'products', _vm.product.product_id)
      }
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding-left": "0"
    }
  }, [(!_vm.product_details.removeProduct) ? _c('button', {
    staticClass: "btn admin-btn",
    staticStyle: {
      "line-height": "2em",
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('removeProduct', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v(" Delete this Product")]) : _vm._e(), _vm._v(" "), (_vm.product_details.removeProduct) ? _c('span', {}, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Do you really want to remove this Product?")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs admin-btn-tiny",
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": _vm.removeProduct
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs admin-btn-tiny",
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7 col-xs-12",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "product-detail-card"
  }, [_c('h6', [_vm._v("Product Items and Variations")]), _vm._v(" "), (_vm.product_details.setProductSettings) ? _c('div', [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    staticStyle: {
      "display": "inline"
    }
  }, [_c('b', [_vm._v("Group Name: ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_groups_set_name),
      expression: "product.product_groups_set_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.product.product_groups_set_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_groups_set_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.product.product_set_items > 0) ? _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('b', [_vm._v("Group Items Name: ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_groups_items_set_name),
      expression: "product.product_groups_items_set_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.product.product_groups_items_set_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_groups_items_set_name = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.editProductSettings
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Cancel")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('hr')]) : _vm._e(), _vm._v(" "), _c('h5', {
    staticStyle: {
      "font-size": "10px",
      "text-transform": "capitalize"
    }
  }, [_c('b', [_vm._v("Name of Group: ")]), _vm._v(_vm._s(_vm.product.product_groups_set_name) + "\r\n                    "), _c('button', {
    staticClass: "btn btn-xs v-tiny-btn admin-btn-tiny",
    staticStyle: {
      "line-height": "0.8"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('setProductSettings', '', '')
      }
    }
  }, [_vm._v(" Change")])]), _vm._v(" "), (((_vm.product.product_set_groups > 0) && (_vm.product.product_set_items > 0))) ? _c('div', _vm._l((_vm.product.product_item_groups), function(pg) {
    return _c('div', {
      staticClass: "row col-xs-12",
      staticStyle: {
        "border-bottom": "1px solid #e9e6e6",
        "margin-bottom": "1em"
      }
    }, [_c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), _c('div', [(_vm.product_details.editProductItemGroup && (_vm.product_item_group.product_item_group_id == pg.product_item_group_id)) ? _c('div', {
      staticClass: "col-sm-12",
      attrs: {
        "id": "editProductItemGroup"
      }
    }, [_c('h6', [_vm._v("Edit Product Item Group")]), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "form-group col-md-12"
    }, [_c('label', [_vm._v("Name\r\n                                    "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product_item_group.product_item_group_name),
        expression: "product_item_group.product_item_group_name"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.product_item_group.product_item_group_name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.product_item_group.product_item_group_name = $event.target.value
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "form-group col-md-12"
    }, [_c('div', {
      staticClass: "box-cube col-xs-2"
    }, [(_vm.product_item_group.product_item_group_is_color_image == 'IMG') ? _c('div', {}, [((_vm.product_item_group.product_item_group_image && (_vm.product_item_group.product_item_group_image != 'error'))) ? _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": _vm.product_item_group.product_item_group_image
      }
    }) : _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.product_item_group.product_item_group_is_color_image == 'COL') ? _c('div', [_c('div', {
      staticClass: "box-color-cube",
      style: ({
        background: pg.product_item_group_color
      })
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('div', {
      staticClass: "form-group col-md-12"
    }, [_c('label', [_vm._v("To change Colour/Image, pick Colour or pick from uploaded Images to match the colour you are adding")])]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('div', {
      staticClass: "form-group col-md-12"
    }, [_c('label', [_vm._v(" Pick Colour\r\n                                        "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product_item_group.product_item_group_color_new),
        expression: "product_item_group.product_item_group_color_new"
      }],
      staticClass: "form-control",
      staticStyle: {
        "width": "4em"
      },
      attrs: {
        "type": "color"
      },
      domProps: {
        "value": (_vm.product_item_group.product_item_group_color_new)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.product_item_group.product_item_group_color_new = $event.target.value
        }
      }
    })])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "form-group col-md-12"
    }, [_c('label', [_vm._v("Or Pick Image")]), _vm._v(" "), _c('div', {
      staticClass: "row img-row"
    }, _vm._l((_vm.product.product_images), function(img, index) {
      return _c('div', {
        key: index,
        staticClass: "col-xs-1",
        staticStyle: {
          "height": "40px",
          "width": "100px",
          "margin-bottom": "5px"
        },
        attrs: {
          "id": "groupImage"
        }
      }, [_c('a', {
        staticStyle: {
          "cursor": "pointer"
        },
        on: {
          "click": function($event) {
            _vm.setComponent('set-product-item-group-image', img.product_image_id)
          }
        }
      }, [_c('img', {
        staticClass: "product-item-group-image sp-prd-img",
        attrs: {
          "id": img.product_image_id + 'PRTG',
          "src": img.product_image,
          "alt": ""
        }
      })])])
    })), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12",
      staticStyle: {
        "z-index": "9"
      }
    }, [_c('div', {
      staticClass: "upload-btn-wrapper",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "id": "uploadDiv"
      }
    }, [_c('button', {
      staticClass: "upload-btn",
      staticStyle: {
        "line-height": "0.6"
      }
    }, [_vm._v("Or Add new Image")]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "file",
        "id": "input-file",
        "accept": "image/*"
      },
      on: {
        "change": function($event) {
          _vm.onFileChange($event, 'products', _vm.product.product_id)
        }
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "form-group col-md-12"
    }, [(_vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
      staticClass: "btn admin-btn",
      staticStyle: {
        "line-height": "1.2",
        "margin-right": "5px"
      },
      attrs: {
        "disabled": _vm.disable_btn,
        "type": "button"
      },
      on: {
        "click": _vm.editProductItemGroup
      }
    }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
      staticClass: "btn admin-btn",
      staticStyle: {
        "line-height": "1.2",
        "margin-right": "5px"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-ban"
    }), _vm._v(" Cancel")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [(_vm.product_details.removeItemGroup && (_vm.product_item_group.product_item_group_id == pg.product_item_group_id)) ? _c('span', {
      staticClass: "pull-left col-sm-12"
    }, [_c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("Do you really want to remove this Item Group?")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-xs admin-btn-tiny",
      on: {
        "click": function($event) {
          _vm.removeProductItemGroup()
        }
      }
    }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-xs admin-btn-tiny",
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-3"
    }, [_c('div', {
      staticStyle: {
        "padding": "1em"
      }
    }, [_c('h4', {
      staticStyle: {
        "font-weight": "bold",
        "text-transform": "capitalize",
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(pg.product_item_group_name))]), _vm._v(" "), _c('div', {
      staticClass: "box-cube"
    }, [(pg.product_item_group_is_color_image == 'IMG') ? _c('div', {
      staticStyle: {
        "height": "40px"
      }
    }, [((pg.product_item_group_image && (pg.product_item_group_image != 'error'))) ? _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": pg.product_item_group_image
      }
    }) : _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]) : _vm._e(), _vm._v(" "), (pg.product_item_group_is_color_image == 'COL') ? _c('div', [_c('div', {
      staticClass: "box-color-cube",
      style: ({
        background: pg.product_item_group_color
      })
    })]) : _vm._e()]), _vm._v(" "), _c('button', {
      staticClass: "btn v-tiny-btn admin-btn-tiny",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('editProductItemGroup', 'productitemgroup', pg)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    }), _vm._v(" Edit")]), _vm._v(" "), (_vm.product.product_item_groups && _vm.product.product_item_groups.length > 1) ? _c('button', {
      staticClass: "btn btn-xs v-tiny-btn admin-btn-tiny",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('removeItemGroup', 'productitemgroup', pg)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    }), _vm._v(" Delete")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-9"
    }, [_c('div', {
      staticStyle: {
        "padding": "1em"
      }
    }, [_c('h5', {
      staticStyle: {
        "font-size": "10px",
        "text-transform": "capitalize"
      }
    }, [_vm._v(_vm._s(_vm.product.product_groups_items_set_name) + "\r\n                            "), _c('button', {
      staticClass: "btn btn-xs v-tiny-btn admin-btn-tiny",
      staticStyle: {
        "line-height": "0.8"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('setProductSettings', '', '')
        }
      }
    }, [_vm._v(" Change")])]), _vm._v(" "), _vm._l((pg.product_items), function(pt) {
      return _c('div', {
        staticClass: "items-list-tiny",
        staticStyle: {
          "display": "inline"
        }
      }, [_c('div', [(_vm.product.product_service == 'P' && (pt.product_item_size)) ? _c('li', {
        staticClass: "box-wrap"
      }, [_vm._v(_vm._s(pt.product_item_size))]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'S' && (pt.product_item_service_tag)) ? _c('li', {
        staticClass: "box-wrap"
      }, [_vm._v(_vm._s(pt.product_item_service_tag))]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('li', [_c('span', [_vm._v("w(kg):")]), _vm._v(_vm._s(pt.product_item_weight))]) : _vm._e(), _vm._v(" "), (pt.product_item_actual_price != 0) ? _c('li', [_c('span', [_vm._v("Price:")]), _vm._v(_vm._s(pt.product_item_actual_price))]) : _c('li', [_c('span', [_vm._v("Price:")]), _vm._v(_vm._s(pt.product_item_price))]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Qty:")]), _vm._v(_vm._s(pt.product_item_quantity))]), _vm._v(" "), _c('li', [_c('a', {
        staticClass: "btn btn-xs v-tiny-btn admin-btn-tiny",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            _vm.setProductComponent('editProductItem', 'productitem', pt)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-pencil"
      })])]), _vm._v(" "), (_vm.product.product_items.length > 1) ? _c('li', [_c('a', {
        staticClass: "btn btn-xs v-tiny-btn admin-btn-tiny",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            _vm.setProductComponent('removeProductItem', 'productitem', pt)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-trash"
      })])]) : _vm._e()]), _vm._v(" "), (_vm.product_details.editProductItem && (_vm.product_item.product_item_id == pt.product_item_id)) ? _c('div', {
        staticClass: "col-sm-12",
        staticStyle: {
          "margin-top": "1em"
        },
        attrs: {
          "id": "editProductItem"
        }
      }, [_c('h6', [_vm._v("Edit Product Item")]), _vm._v(" "), _c('form', [_c('div', {
        staticClass: "row"
      }, [_c('div', {
        staticClass: "form-group"
      }, [_c('label', [_vm._v(" *"), (_vm.product.product_service == 'P') ? _c('span', [_vm._v("Product Item Size")]) : _vm._e(), (_vm.product.product_service == 'S') ? _c('span', [_vm._v("Product Item tYPE")]) : _vm._e(), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.product_item.product_item_size),
          expression: "product_item.product_item_size"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "text",
          "value": "",
          "placeholder": ""
        },
        domProps: {
          "value": (_vm.product_item.product_item_size)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.product_item.product_item_size = $event.target.value
          }
        }
      })])]), _vm._v(" "), (_vm.product.product_service == 'S') ? _c('div', {
        staticClass: "form-group",
        attrs: {
          "cla": ""
        }
      }, [_c('label', [_vm._v(" *Service Tag\r\n                                    "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.product_item.product_item_service_tag),
          expression: "product_item.product_item_service_tag"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "number",
          "placeholder": ""
        },
        domProps: {
          "value": (_vm.product_item.product_item_service_tag)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.product_item.product_item_service_tag = $event.target.value
          }
        }
      })])]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "form-group"
      }, [_c('label', [_vm._v(" *Product Item Price\r\n                                          "), (_vm.product_item.product_item_actual_price != 0) ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.product_item.product_item_actual_price),
          expression: "product_item.product_item_actual_price"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "number",
          "value": "",
          "placeholder": ""
        },
        domProps: {
          "value": (_vm.product_item.product_item_actual_price)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.product_item.product_item_actual_price = $event.target.value
          }
        }
      }) : _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.product_item.product_item_price),
          expression: "product_item.product_item_price"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "number",
          "value": "",
          "placeholder": ""
        },
        domProps: {
          "value": (_vm.product_item.product_item_price)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.product_item.product_item_price = $event.target.value
          }
        }
      })])]), _vm._v(" "), _c('div', {
        staticClass: "form-group"
      }, [_c('label', [_vm._v(" *Product Item Weight\r\n                                        "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.product_item.product_item_weight),
          expression: "product_item.product_item_weight"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "number",
          "step": "any",
          "placeholder": ""
        },
        domProps: {
          "value": (_vm.product_item.product_item_weight)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.product_item.product_item_weight = $event.target.value
          }
        }
      })])]), _vm._v(" "), _c('div', {
        staticClass: "form-group"
      }, [_c('label', [_vm._v(" *Product Item Quantity\r\n                                        "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.product_item.product_item_quantity),
          expression: "product_item.product_item_quantity"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "number",
          "placeholder": ""
        },
        domProps: {
          "value": (_vm.product_item.product_item_quantity)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.product_item.product_item_quantity = $event.target.value
          }
        }
      })])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
        staticClass: "col-md-12"
      }, [(_vm.action_loading) ? _c('div', {
        staticClass: "loading-sm"
      }) : _vm._e(), _vm._v(" "), _c('p', {
        staticStyle: {
          "color": "#ff0000"
        }
      }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
        staticClass: "btn admin-btn",
        staticStyle: {
          "line-height": "1.2",
          "margin-right": "5px"
        },
        attrs: {
          "disabled": _vm.disable_btn,
          "type": "button"
        },
        on: {
          "click": _vm.editProductItem
        }
      }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
        staticClass: "btn admin-btn",
        staticStyle: {
          "line-height": "1.2",
          "margin-right": "5px"
        },
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            _vm.setComponent('reset-edit', '')
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-ban"
      }), _vm._v(" Cancel")])]), _vm._v(" "), _c('br')])])]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.product_details.removeProductItem && (_vm.product_item.product_item_id == pt.product_item_id)) ? _c('span', {
        staticClass: "pull-left col-sm-12"
      }, [_c('p', {
        staticStyle: {
          "color": "#ff0000"
        }
      }, [_vm._v("Do you really want to remove this Item?")]), _vm._v(" "), _c('button', {
        staticClass: "btn btn-xs admin-btn-tiny",
        attrs: {
          "disabled": _vm.disable_btn
        },
        on: {
          "click": function($event) {
            _vm.removeProductItem()
          }
        }
      }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
        staticClass: "btn btn-xs admin-btn-tiny",
        on: {
          "click": function($event) {
            _vm.setComponent('reset-edit', '')
          }
        }
      }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
        staticClass: "loading-sm"
      }) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "clearfix"
      })])
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-xs v-tiny-btn admin-btn-tiny",
      staticStyle: {
        "line-height": "0.8"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('addProductItemToGroup', 'productitemgroup', pg)
        }
      }
    }, [_vm._v(" Add New Item")])], 2)]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.product_details.addProductItemToGroup && (_vm.product_item_group.product_item_group_id == pg.product_item_group_id)) ? _c('div', {
      staticClass: "row col-md-12"
    }, [(_vm.product.product_service == 'S') ? _c('div', {
      staticClass: "col-md-4 col-xs-3"
    }, [_c('label', [_vm._v(" Service Tag\r\n                                "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product.product_item_service_tag),
        expression: "product.product_item_service_tag"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": ""
      },
      domProps: {
        "value": (_vm.product.product_item_service_tag)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.product.product_item_service_tag = $event.target.value
        }
      }
    })])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col-md-3 col-xs-3"
    }, [_c('label', [_vm._v(" Price\r\n                                "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product.product_item_price),
        expression: "product.product_item_price"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "value": "",
        "placeholder": ""
      },
      domProps: {
        "value": (_vm.product.product_item_price)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.product.product_item_price = $event.target.value
        }
      }
    })])]), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('div', {
      staticClass: "col-md-3 col-xs-3"
    }, [_c('label', [_vm._v(" Weight(KG)\r\n                                "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product.product_item_weight),
        expression: "product.product_item_weight"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "step": "any",
        "placeholder": ""
      },
      domProps: {
        "value": (_vm.product.product_item_weight)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.product.product_item_weight = $event.target.value
        }
      }
    })])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col-md-3 col-xs-3"
    }, [_c('label', [_vm._v(" Quantity\r\n                                "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product.product_item_quantity),
        expression: "product.product_item_quantity"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "placeholder": ""
      },
      domProps: {
        "value": (_vm.product.product_item_quantity)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.product.product_item_quantity = $event.target.value
        }
      }
    })])]), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('div', {
      staticClass: "col-md-3 col-xs-3"
    }, [_c('label', [_vm._v("Attributes (eg: Size, Plan, Length etc,)\r\n                                "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product.product_item_size),
        expression: "product.product_item_size"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": ""
      },
      domProps: {
        "value": (_vm.product.product_item_size)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.product.product_item_size = $event.target.value
        }
      }
    })])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col-md-6"
    }, [_c('p', {
      staticClass: "data-error-message"
    }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), _c('p', {
      staticClass: "data-success-message"
    }, [_vm._v(_vm._s(_vm.data_success_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn admin-btn",
      staticStyle: {
        "background": "#e7e8e9"
      },
      attrs: {
        "disabled": _vm.disable_btn,
        "type": "button"
      },
      on: {
        "click": _vm.addProductItem
      }
    }, [_vm._v("Add Item")]), _vm._v(" "), _c('button', {
      staticClass: "btn admin-btn",
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_vm._v("Cancel")])])]) : _vm._e()])
  })) : _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("You have not set any product item variation")])]), _vm._v(" "), _c('div', {}, [_c('p', [_vm._v("add other variations like groups or types of this product eg. colors, materials, plans, sizes etc")]), _vm._v(" "), (_vm.product.product_set_groups == 0) ? _c('div', [_c('p', [_c('b', [_vm._v(_vm._s(_vm.product.product_groups_set_name))]), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn-tiny",
    staticStyle: {
      "line-height": "0.8"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('setProductSettings', '', '')
      }
    }
  }, [_vm._v(" Change this Name")])])]) : _vm._e(), _vm._v(" "), (!_vm.product_details.addProductItemPanel) ? _c('button', {
    staticClass: "btn admin-btn",
    staticStyle: {
      "line-height": "1.2"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('addProductItemPanel', '', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add Product Variation")]) : _c('div', [(_vm.product_details.addProductItemPanel) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('h6', [_vm._v("Add New Variation "), (_vm.product.product_groups_set_name) ? _c('span', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("(Set " + _vm._s(_vm.product.product_groups_set_name) + ")")]) : _vm._e()]), _vm._v(" "), _c('form', {
    staticClass: "gw-form",
    staticStyle: {
      "margin-top": "1em",
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.product.product_set_groups > 0) ? _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "line-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showProductItemGroups),
      expression: "showProductItemGroups"
    }],
    staticStyle: {
      "height": "1em"
    },
    attrs: {
      "type": "radio",
      "value": "showtrue"
    },
    domProps: {
      "checked": _vm._q(_vm.showProductItemGroups, "showtrue")
    },
    on: {
      "__c": function($event) {
        _vm.showProductItemGroups = "showtrue"
      }
    }
  }), _vm._v(" "), _vm._v("\r\n                                               Add new Items to "), _c('span', [_vm._v(_vm._s(_vm.product.product_groups_set_name))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "line-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showProductItemGroups),
      expression: "showProductItemGroups"
    }],
    staticStyle: {
      "height": "1em"
    },
    attrs: {
      "type": "radio",
      "value": "showfalse"
    },
    domProps: {
      "checked": _vm._q(_vm.showProductItemGroups, "showfalse")
    },
    on: {
      "__c": function($event) {
        _vm.showProductItemGroups = "showfalse"
      }
    }
  }), _vm._v("\r\n                                                   Or Add new " + _vm._s(_vm.product.product_groups_set_name) + "\r\n                                           ")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.showProductItemGroups == 'showtrue') ? _c('div', [((_vm.product.product_item_groups.length && _vm.product.product_item_groups.length > 0)) ? _c('div', {
    staticClass: "row col-md-12",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._l((_vm.product.product_item_groups), function(pg, pgdex) {
    return _c('div', {
      key: pgdex,
      staticClass: "col-xs-2"
    }, [_c('div', {
      staticStyle: {
        "padding": "5px",
        "margin-bottom": "5px",
        "width": "10%"
      }
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": pg.product_item_group_name
      },
      on: {
        "click": function($event) {
          _vm.setInnerComponent('set-product-item-group', pg.product_item_group_id)
        }
      }
    }, [(pg.product_item_group_is_color_image == 'IMG') ? _c('div', [_c('div', {
      staticClass: "box-color-cube"
    }, [_c('img', {
      staticClass: "product-item-group sp-prd-img",
      attrs: {
        "src": pg.product_item_group_image,
        "id": pg.product_item_group_id + 'PRTGR'
      }
    })])]) : _vm._e(), _vm._v(" "), (pg.product_item_group_is_color_image == 'COL') ? _c('div', [_c('div', {
      staticClass: "product-item-group",
      attrs: {
        "id": pg.product_item_group_id + 'PRTGR'
      }
    }, [_c('div', {
      staticClass: "box-color-cube",
      staticStyle: {
        "height": "3em",
        "width": "85%"
      },
      style: ({
        background: pg.product_item_group_color
      })
    })])]) : _vm._e(), _vm._v(" "), _c('p', {
      staticStyle: {
        "font-weight": "bold",
        "font-size": "12px",
        "line-height": "1.2"
      }
    }, [_vm._v("Add to " + _vm._s(pg.product_item_group_name) + " ")])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showProductItemGroups == 'showfalse') ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Name of new " + _vm._s(_vm.product.product_groups_set_name) + "\r\n                                                   "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_group_name),
      expression: "product.product_item_group_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.product.product_item_group_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_group_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('div', {}, [_c('label', [_vm._v(" Pick Colour or Pick from uploaded Images to match the colour you are adding")])]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(" Pick Colour\r\n                                                       "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_group_color),
      expression: "product.product_item_group_color"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "4em"
    },
    attrs: {
      "type": "color"
    },
    domProps: {
      "value": (_vm.product.product_item_group_color)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_group_color = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "border": "1px dashed #eeccee",
      "padding": "1em"
    }
  }, [_c('label', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(" Or Pick Media")]), _vm._v(" "), _c('div', {
    staticClass: "row img-row"
  }, _vm._l((_vm.product.product_images), function(img, index) {
    return _c('div', {
      key: index,
      staticClass: "col-xs-1",
      staticStyle: {
        "height": "50px",
        "width": "70px"
      },
      attrs: {
        "id": "groupImage"
      }
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setInnerComponent('set-product-item-group-image', img.product_image_id)
        }
      }
    }, [_c('img', {
      staticClass: "product-item-group-image sp-prd-img",
      attrs: {
        "id": img.product_image_id + 'PRTG',
        "src": img.product_image,
        "alt": ""
      }
    })])])
  })), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "z-index": "9"
    }
  }, [_c('p', {
    staticClass: "p-tiny-info"
  }, [_vm._v(_vm._s(_vm.max_media_info))]), _vm._v(" "), _c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('button', {
    staticClass: "upload-btn",
    staticStyle: {
      "line-height": "0.4",
      "font-size": "14px"
    }
  }, [_vm._v("Or Add new Image or Video ")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "video/*,image/*",
      "capture": ""
    },
    on: {
      "change": function($event) {
        _vm.onFileChangeProductItems($event, 'products', _vm.product.product_id)
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "data-error-message"
  }, [_vm._v(_vm._s(_vm.data_media_error_message))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('br')]), _vm._v(" "), ((_vm.showProductItemGroups == 'showtrue') || (_vm.showProductItemGroups == 'showfalse')) ? _c('div', {
    staticClass: "row col-md-12"
  }, [(_vm.product.product_service == 'S') ? _c('div', {
    staticClass: "col-md-4 col-xs-3"
  }, [_c('label', [_vm._v(" Service Tag\r\n                                                   "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_service_tag),
      expression: "product.product_item_service_tag"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_item_service_tag)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_service_tag = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-3"
  }, [_c('label', [_vm._v(" Price\r\n                                                   "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_price),
      expression: "product.product_item_price"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_item_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_price = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('div', {
    staticClass: "col-md-3 col-xs-3"
  }, [_c('label', [_vm._v(" Weight(KG)\r\n                                                   "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_weight),
      expression: "product.product_item_weight"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "step": "any",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_item_weight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_weight = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-3"
  }, [_c('label', [_vm._v(" Quantity\r\n                                                   "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_quantity),
      expression: "product.product_item_quantity"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_item_quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_quantity = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('div', {
    staticClass: "col-md-3 col-xs-3"
  }, [_c('label', [_vm._v("Attributes (eg: Size, Plan, Length etc,)\r\n                                                   "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_size),
      expression: "product.product_item_size"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_item_size)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_size = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('p', {
    staticClass: "data-error-message"
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), _c('p', {
    staticClass: "data-success-message"
  }, [_vm._v(_vm._s(_vm.data_success_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn",
    staticStyle: {
      "background": "#e7e8e9"
    },
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.addProductItem
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn",
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])])]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Cancel")])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', {
    staticClass: "col-md-4 col-xs-12"
  }, [_c('div', {
    staticClass: "product-detail-card"
  }, [_c('h6', [_vm._v("DISCOUNTS AND COUPONS")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [(_vm.product_details.setProductDiscount || _vm.product_details.setProductItemDiscount) ? _c('div', [_c('div', {
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [(_vm.product_details.setProductDiscount) ? _c('label', [_vm._v("Set Product Coupon Or Discount")]) : _vm._e(), _vm._v(" "), (_vm.product_details.setProductItemDiscount) ? _c('label', [_vm._v("Set Product Item Coupon Or Discount")]) : _vm._e(), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.is_discount_coupon),
      expression: "discount_coupon.is_discount_coupon"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.discount_coupon.is_discount_coupon = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "D"
    }
  }, [_vm._v("Discount")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "C"
    }
  }, [_vm._v("Coupon")])])]), _vm._v(" "), (((_vm.product.product_discounts_active == 1) || (_vm.product_item.product_item_discounts_active == 1))) ? _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("You have an active Discount")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Percentage Discount")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_percentage),
      expression: "discount_coupon.discount_percentage"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "100"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_percentage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_percentage = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Start Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_start_date),
      expression: "discount_coupon.discount_start_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_start_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("End Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_end_date),
      expression: "discount_coupon.discount_end_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_end_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_end_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn",
    staticStyle: {
      "line-height": "1.2"
    },
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.setDiscountsAndCoupons()
      }
    }
  }, [_vm._v("SET")]), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn",
    staticStyle: {
      "line-height": "1.2"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])])]), _vm._v(" "), _vm._m(26)]) : _vm._e(), _vm._v(" "), (_vm.product_details.editDiscount) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('h5', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("Edit Discount")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Percentage Discount")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_percentage),
      expression: "discount_coupon.discount_percentage"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "100"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_percentage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_percentage = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Start Date: " + _vm._s(_vm.discount_coupon.discount_start_date))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_start_date),
      expression: "discount_coupon.discount_start_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "datetime-local"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_start_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("End Date: " + _vm._s(_vm.discount_coupon.discount_end_date))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_end_date),
      expression: "discount_coupon.discount_end_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "datetime-local"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_end_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_end_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn",
    staticStyle: {
      "line-height": "2em"
    },
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.editDiscountsAndCoupons()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn",
    staticStyle: {
      "line-height": "2em"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])])])]) : _vm._e(), _vm._v(" "), (!(_vm.product_details.setProductDiscount || _vm.product_details.setProductItemDiscount) && !_vm.product_details.editDiscount) ? _c('div', [_c('button', {
    staticClass: "btn admin-btn-tiny",
    staticStyle: {
      "line-height": "2em"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('viewProductDiscounts', '', '')
      }
    }
  }, [_vm._v("View Product Discounts and Coupons")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn-tiny",
    staticStyle: {
      "line-height": "2em"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('viewProductItemsDiscounts', '', '')
      }
    }
  }, [_vm._v("View Product Items Discounts and Coupons")])]) : _vm._e(), _vm._v(" "), (_vm.product_details.viewCoupons) ? _c('div', {
    staticStyle: {
      "margin-top": "2em",
      "border": "#e9e6e6 dashed 1px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "5px"
    }
  }, [_c('h6', {
    staticClass: "pull-left",
    staticStyle: {
      "text-transform": "uppercase",
      "font-size": "14px"
    }
  }, [_vm._v("Item Coupons and Discounts")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs v-tiny-btn admin-btn-tiny pull-right",
    staticStyle: {
      "line-height": "1.2"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "items-list-tiny",
    staticStyle: {
      "display": "inline"
    }
  }, [(_vm.product_item.product_item_group_is_color_image == 'IMG') ? _c('li', [((_vm.product_item.product_item_group_image && (_vm.product_item.product_item_group_image != 'error'))) ? _c('img', {
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "src": _vm.product_item.product_item_group_image
    }
  }) : _c('img', {
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "src": "/static/assets/images/dummy-image.png"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.product_item.product_item_group_is_color_image == 'COL') ? _c('li', [_c('a', {
    staticClass: "btn box-color-cube",
    style: ({
      background: _vm.product_item.product_item_group_color
    })
  })]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'P' && (_vm.product_item.product_item_size)) ? _c('li', {
    staticClass: "box-wrap"
  }, [_vm._v(_vm._s(_vm.product_item.product_item_size))]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'S' && (_vm.product_item.product_item_service_tag)) ? _c('li', {
    staticClass: "box-wrap"
  }, [_vm._v(_vm._s(_vm.product_item.product_item_service_tag))]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('li', [_c('span', [_vm._v("w(kg):")]), _vm._v(_vm._s(_vm.product_item.product_item_weight))]) : _vm._e(), _vm._v(" "), _c('li', [_c('span', [_vm._v("Price:")]), _vm._v(_vm._s(_vm.product_item.product_item_actual_price))]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Qty:")]), _vm._v(_vm._s(_vm.product_item.product_item_quantity))]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('hr')]), _vm._v(" "), _vm._l((_vm.product_item.product_item_discounts), function(dc) {
    return _c('div', [(dc.discount_type == 5) ? _c('div', [_c('div', {
      staticStyle: {
        "background": "#d1ddf1",
        "text-align": "center"
      }
    }, [(dc.discount_coupon == 'D') ? _c('p', [_c('b', [_vm._v("Discount")])]) : _vm._e(), _vm._v(" "), (dc.discount_coupon == 'C') ? _c('p', [_c('b', [_vm._v("Coupon:")]), _vm._v(" (Code: " + _vm._s(dc.discount_coupon_code) + " )")]) : _vm._e()]), _vm._v(" "), _c('p', [_c('b', [_vm._v("%Discount: ")]), _vm._v(_vm._s(dc.discount_percentage) + "%")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Start Date: ")]), _vm._v(_vm._s(dc.discount_start_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("End Date: ")]), _vm._v(_vm._s(dc.discount_end_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Status: ")]), _vm._v(_vm._s(dc.discount_status))]), _vm._v(" "), _c('div', [(dc.discount_status_id == 5) ? _c('p', [_c('a', {
      staticStyle: {
        "cursor": "pointer",
        "text-decoration": "underline",
        "font-size": "13px",
        "color": "#448aff"
      },
      attrs: {
        "title": "Edit"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('editDiscount', '', dc)
        }
      }
    }, [_vm._v("\r\n                                  Edit Discount")]), _vm._v("    \r\n                                "), _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "text-decoration": "underline",
        "font-size": "13px",
        "color": "#448aff"
      },
      attrs: {
        "title": "De-Activate"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('deactivateDiscount', _vm.product_item, dc)
        }
      }
    }, [_vm._v("\r\n                                  Deactivate Discount")])]) : _vm._e(), (_vm.action_loading && (_vm.product_item.product_item_id == _vm.product_item.product_item_id)) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), _c('p')]), _vm._v(" "), _c('hr')]) : _vm._e()])
  }), _vm._v(" "), _c('div', [(_vm.product_item.product_item_only_coupon_discount_count == 0) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("No set discount or coupon")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn",
    staticStyle: {
      "line-height": "1.2"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('setProductItemDiscount', 'productitem', _vm.product_item)
      }
    }
  }, [_vm._v("Set New Item Discount Or Coupon")])])], 2) : _vm._e(), _vm._v(" "), (_vm.product_details.viewProductItemsDiscounts) ? _c('div', {
    staticStyle: {
      "margin-top": "1em",
      "border": "#0d022b dashed 1px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "1em"
    }
  }, [_c('h6', {
    staticClass: "pull-left",
    staticStyle: {
      "text-transform": "uppercase",
      "font-size": "14px"
    }
  }, [_vm._v("Items in this Product")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs v-tiny-btn admin-btn-tiny pull-right",
    staticStyle: {
      "line-height": "1.2"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _vm._l((_vm.product.product_items), function(productItem) {
    return _c('div', {
      staticStyle: {
        "border": "dashed #d1ddf1",
        "padding": "5px",
        "margin-bottom": "1em"
      }
    }, [_c('div', {
      staticClass: "items-list-tiny",
      staticStyle: {
        "display": "inline"
      }
    }, [(productItem.product_item_group_is_color_image == 'IMG') ? _c('li', [((productItem.product_item_group_image && (productItem.product_item_group_image != 'error'))) ? _c('img', {
      staticStyle: {
        "height": "30px"
      },
      attrs: {
        "src": productItem.product_item_group_image
      }
    }) : _c('img', {
      staticStyle: {
        "height": "30px"
      },
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]) : _vm._e(), _vm._v(" "), (productItem.product_item_group_is_color_image == 'COL') ? _c('li', [_c('a', {
      staticClass: "btn box-color-cube",
      style: ({
        background: productItem.product_item_group_color
      })
    })]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'P' && (productItem.product_item_size)) ? _c('li', {
      staticClass: "box-wrap"
    }, [_vm._v(_vm._s(productItem.product_item_size))]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'S' && (productItem.product_item_service_tag)) ? _c('li', {
      staticClass: "box-wrap"
    }, [_vm._v(_vm._s(productItem.product_item_service_tag))]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('li', [_c('span', [_vm._v("w(kg):")]), _vm._v(_vm._s(productItem.product_item_weight))]) : _vm._e(), _vm._v(" "), _c('li', [_c('span', [_vm._v("Price:")]), _vm._v(_vm._s(productItem.product_item_actual_price))]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Qty:")]), _vm._v(_vm._s(productItem.product_item_quantity))]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]), _vm._v(" "), (_vm.product_details.viewCoupons && (productItem.product_item_id == _vm.product_item.product_item_id)) ? _c('div', {
      staticStyle: {
        "display": "none"
      }
    }, [_c('div', [_c('button', {
      staticClass: "btn btn-xs v-tiny-btn admin-btn-tiny",
      staticStyle: {
        "line-height": "1.2"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_vm._v("Close")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-xs v-tiny-btn admin-btn-tiny",
      staticStyle: {
        "line-height": "1.2"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('setProductItemDiscount', 'productitem', productItem)
        }
      }
    }, [_vm._v("Set New Item Discount Or Coupon")])]), _vm._v(" "), _vm._l((productItem.product_item_discounts), function(dc) {
      return _c('div', [_c('div', [((dc.discount_type == 5)) ? _c('p', [_c('b', [_vm._v("Product Item Discount")])]) : _vm._e(), _vm._v(" "), ((dc.discount_type == 4)) ? _c('p', [_c('b', [_vm._v("General Product Discount")])]) : _vm._e(), _vm._v(" "), (!(dc.discount_type == 4) && !(dc.discount_type == 5)) ? _c('p', [_c('b', [_vm._v("General Sellpoint Discount")])]) : _vm._e(), _vm._v(" "), _c('div', {
        staticStyle: {
          "background": "#d1ddf1",
          "text-align": "center"
        }
      }, [(dc.discount_coupon == 'D') ? _c('p', [_c('b', [_vm._v("Discount")])]) : _vm._e(), _vm._v(" "), (dc.discount_coupon == 'C') ? _c('p', [_c('b', [_vm._v("Coupon:")]), _vm._v(" (Code: " + _vm._s(dc.discount_coupon_code) + " )")]) : _vm._e()]), _vm._v(" "), _c('p', [_c('b', [_vm._v("%Discount: ")]), _vm._v(_vm._s(dc.discount_percentage) + "%")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Start Date: ")]), _vm._v(_vm._s(dc.discount_start_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("End Date: ")]), _vm._v(_vm._s(dc.discount_end_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Status: ")]), _vm._v(_vm._s(dc.discount_status))]), _vm._v(" "), ((dc.discount_type == 4) || (dc.discount_type == 5)) ? _c('div', [(dc.discount_status_id == 5) ? _c('p', [_c('a', {
        staticStyle: {
          "cursor": "pointer",
          "text-decoration": "underline",
          "font-size": "13px",
          "color": "#448aff"
        },
        attrs: {
          "title": "Edit"
        },
        on: {
          "click": function($event) {
            _vm.setProductComponent('editDiscount', '', dc)
          }
        }
      }, [_vm._v("\r\n                                    Edit Discount")]), _vm._v("    \r\n                                  "), _c('a', {
        staticStyle: {
          "cursor": "pointer",
          "text-decoration": "underline",
          "font-size": "13px",
          "color": "#448aff"
        },
        attrs: {
          "title": "De-Activate"
        },
        on: {
          "click": function($event) {
            _vm.setProductComponent('deactivateDiscount', productItem, dc)
          }
        }
      }, [_vm._v("\r\n                                    Deactivate Discount")])]) : _vm._e(), (_vm.action_loading && (productItem.product_item_id == _vm.product_item.product_item_id)) ? _c('div', {
        staticClass: "loading-sm"
      }) : _vm._e(), _vm._v(" "), _c('p')]) : _c('p', {
        staticStyle: {
          "color": "#ff0000"
        }
      }, [_vm._v("Edit/Deactivate at Business Settings")]), _vm._v(" "), _c('hr')])])
    }), _vm._v(" "), _c('div', [(productItem.product_item_discounts && _vm.product_item.product_item_discounts.length == 0) ? _c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("No set discount or coupon")]) : _vm._e()])], 2) : _c('button', {
      staticClass: "btn btn-xs v-tiny-btn admin-btn-tiny",
      staticStyle: {
        "line-height": "2em"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('viewCoupons', 'productitem', productItem)
        }
      }
    }, [_vm._v("View Coupons and Discounts")])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.product_details.viewProductDiscounts) ? _c('div', {
    staticStyle: {
      "margin-top": "2em"
    }
  }, [(_vm.product.product_items[0]) ? _c('div', [_c('div', {
    staticStyle: {
      "margin": "5px"
    }
  }, [_c('h6', {
    staticClass: "pull-left",
    staticStyle: {
      "text-transform": "uppercase",
      "font-size": "14px"
    }
  }, [_vm._v("Product Coupons and Discounts")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs v-tiny-btn admin-btn-tiny pull-right",
    staticStyle: {
      "line-height": "1.2"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _vm._l((_vm.product.product_items[0].product_item_discounts), function(dc) {
    return _c('div', [((dc.discount_type == 4)) ? _c('div', [_c('div', {
      staticStyle: {
        "background": "#d1ddf1",
        "text-align": "center"
      }
    }, [(dc.discount_coupon == 'D') ? _c('p', [_c('b', [_vm._v("Discount")])]) : _vm._e(), _vm._v(" "), (dc.discount_coupon == 'C') ? _c('p', [_c('b', [_vm._v("Coupon:")]), _vm._v(" (Code: " + _vm._s(dc.discount_coupon_code) + " )")]) : _vm._e()]), _vm._v(" "), _c('p', [_c('b', [_vm._v("%Discount: ")]), _vm._v(_vm._s(dc.discount_percentage) + "%")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Start Date: ")]), _vm._v(_vm._s(dc.discount_start_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("End Date: ")]), _vm._v(_vm._s(dc.discount_end_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Status: ")]), _vm._v(_vm._s(dc.discount_status))]), _vm._v(" "), ((dc.discount_type == 4) || (dc.discount_type == 5)) ? _c('div', [(dc.discount_status_id == 5) ? _c('p', [_c('a', {
      staticStyle: {
        "cursor": "pointer",
        "text-decoration": "underline",
        "font-size": "13px",
        "color": "#448aff"
      },
      attrs: {
        "title": "Edit"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('editDiscount', '', dc)
        }
      }
    }, [_vm._v("\r\n                                    Edit Discount")]), _vm._v("    \r\n                                  "), _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "text-decoration": "underline",
        "font-size": "13px",
        "color": "#448aff"
      },
      attrs: {
        "title": "De-Activate"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('deactivateDiscount', _vm.product.product_items[0], dc)
        }
      }
    }, [_vm._v("\r\n                                    Deactivate Discount")])]) : _vm._e(), (_vm.action_loading && (_vm.product.product_items[0].product_item_id == _vm.product_item.product_item_id)) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), _c('p')]) : _c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("Edit/Deactivate at Business Settings")]), _vm._v(" "), _c('hr')]) : _vm._e()])
  }), _vm._v(" "), (_vm.product.product_only_coupon_discount_count == 0) ? _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("No set discount or coupon")])]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn-tiny",
    staticStyle: {
      "line-height": "2em"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('setProductDiscount', '', '')
      }
    }
  }, [_vm._v("Set New Product Discount Or Coupon")])]) : _vm._e()]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-xs-12"
  }, [_c('div', {
    staticClass: "product-detail-card"
  }, [_c('div', [_c('h6', [_vm._v("DELIVERY & RETURNS INFORMATION")]), _vm._v(" "), (_vm.product_details.edit_product_delivery) ? _c('div', {}, [_c('div', {
    staticClass: "form-group"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_delivery_returns),
      expression: "product.product_delivery_returns"
    }],
    domProps: {
      "value": (_vm.product.product_delivery_returns)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_delivery_returns = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.setProductDelivery()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v("submit")]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" cancel")])])]) : _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000",
      "line-height": "1.2",
      "font-size": "13px"
    }
  }, [_vm._v("Set delivery and returns information for this product, Note that this is different from setting delivery places\r\n                      "), (_vm.product.product_delivery_returns) ? _c('span', [_vm._v(_vm._s(_vm.product.product_delivery_returns))]) : _vm._e(), _c('br'), _vm._v(" "), _c('button', {
    staticStyle: {
      "font-size": "13px"
    },
    attrs: {
      "type": "btn admin-btn",
      "title": "Edit"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('edit_product_delivery', '', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  }), _vm._v(" Set Delivery & Return Information")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('hr')])]), _vm._v(" "), _c('div', {}, [_c('h6', {
    staticClass: "margin-t-40"
  }, [_vm._v("Set How Product Shipping Fee would affect Buyers Checkout Ordering")]), _vm._v(" "), _c('span', [_c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product_set_shipping_fee_status),
      expression: "product_set_shipping_fee_status"
    }],
    attrs: {
      "type": "radio",
      "id": "12",
      "value": "12"
    },
    domProps: {
      "checked": _vm._q(_vm.product_set_shipping_fee_status, "12")
    },
    on: {
      "click": function($event) {
        _vm.setProductShippingFeeStatus()
      },
      "__c": function($event) {
        _vm.product_set_shipping_fee_status = "12"
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Charge Product Delivery Fee only once on all Quantity of Product Ordered")])])]), _vm._v(" "), _c('span', [_c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product_set_shipping_fee_status),
      expression: "product_set_shipping_fee_status"
    }],
    attrs: {
      "type": "radio",
      "id": "13",
      "value": "13"
    },
    domProps: {
      "checked": _vm._q(_vm.product_set_shipping_fee_status, "13")
    },
    on: {
      "click": function($event) {
        _vm.setProductShippingFeeStatus()
      },
      "__c": function($event) {
        _vm.product_set_shipping_fee_status = "13"
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Charge Product Delivery Fee on each Quantity of Product Ordered")])])]), _vm._v(" "), (_vm.set_shipping_fee_status_track && _vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('br'), _c('br')])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-xs-12"
  }, [_c('div', {
    staticClass: "product-detail-card"
  }, [_c('h6', [_vm._v("Product Delivery Location Fees")]), _vm._v(" "), ((_vm.product.product_business_delivery_options) && (_vm.product.product_business_delivery_options.length != 0)) ? _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("You have set some general delivery settings")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "12px"
    }
  }, [_vm._v("You can set a different delivery fee for this product")]), _vm._v(" "), _vm._l((_vm.product.product_business_delivery_options), function(delivery) {
    return _c('li', [_c('b', [_vm._v(_vm._s(delivery.business_delivery_option))]), _vm._v(" "), (delivery.business_products_delivery_fees.length > 0) ? _c('span', _vm._l((delivery.business_products_delivery_fees), function(fee, fdex) {
      return _c('span', [((fee.product_delivery_product == _vm.product.product_id)) ? _c('span', [_vm._v(" -  ₦" + _vm._s(fee.product_delivery_fee) + "\r\n                            ")]) : _vm._e()])
    })) : _c('span'), _vm._v(" "), (_vm.product_details.setProductDeliveryInformation && delivery.edit_set) ? _c('div', {
      staticClass: "contact_form"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("Delivery Amount")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (delivery.product_delivery_fee),
        expression: "delivery.product_delivery_fee"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "required": ""
      },
      domProps: {
        "value": (delivery.product_delivery_fee)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          delivery.product_delivery_fee = $event.target.value
        }
      }
    }), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#ff0000",
        "font-size": "12px"
      }
    }, [_vm._v("Business Set Shipping Fee: ₦" + _vm._s(delivery.business_delivery_option_price))])]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [(_vm.product_details.setProductDeliveryInformation && _vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn admin-btn",
      staticStyle: {
        "line-height": "1.6",
        "padding": "10px"
      },
      attrs: {
        "disabled": _vm.disable_btn,
        "title": "save",
        "type": "submit"
      },
      on: {
        "click": _vm.setProductDeliveryOption
      }
    }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
      staticClass: "btn admin-btn",
      staticStyle: {
        "line-height": "1.6",
        "padding": "10px"
      },
      attrs: {
        "title": "cancel",
        "type": "submit"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_vm._v("Cancel")])])]) : _vm._e(), _vm._v(" "), _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "font-size": "10px"
      },
      attrs: {
        "type": "btn",
        "title": "Set Product Delivery Fee"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('setProductDeliveryInformation', delivery)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    }), _vm._v(" Set Fee")])])
  })], 2) : _c('div', [_c('p', [_vm._v("You have not set your Business Delivery Locations")])])])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.manageLookbooks) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('h6', {
    staticStyle: {
      "margin-left": "1em",
      "margin-right": "2em"
    }
  }, [_vm._v("Lookbooks (" + _vm._s(_vm.sellpoint.business_total_gallery) + ")")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), (_vm.component_view.viewLookbooks) ? _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    directives: [{
      name: "drag-and-drop",
      rawName: "v-drag-and-drop:options",
      value: (_vm.drag_options),
      expression: "drag_options",
      arg: "options"
    }]
  }, [_c('ul', {
    staticClass: "row"
  }, _vm._l((_vm.galleria), function(gallery, gndex) {
    return _c('li', {
      key: gallery.gallery_posts_group_id,
      staticClass: "col-md-2 col-sm-3 col-xs-3"
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setComponentView('lookbooks', gallery, 'viewLookbook')
        }
      }
    }, [_c('div', {
      staticClass: "info-card info-card-lookbook"
    }, [_c('div', {
      staticClass: "container info-card-body"
    }, [_c('div', {
      staticClass: "info-card-row info-card-lookbook-row"
    }, [_c('div', {}, [(gallery.gallery_posts_group_posts_media.length > 0) ? _c('div', {
      staticClass: "info-card-lookbook-image",
      staticStyle: {
        "margin": "5px"
      }
    }, [(_vm.checkIfVideo(gallery.gallery_posts_group_posts_media[0].gallery_post_media)) ? _c('img', {
      staticClass: "sp-prd-img-cs",
      attrs: {
        "src": "/static/assets/images/video-placeholder.png"
      }
    }) : _c('img', {
      staticClass: "sp-prd-img-cs",
      attrs: {
        "src": gallery.gallery_posts_group_posts_media[0].gallery_post_media
      }
    })]) : _c('div', {
      staticStyle: {
        "margin": "5px"
      }
    }, [_c('img', {
      staticClass: "sp-prd-img-cs",
      attrs: {
        "src": "/static/assets/images/dummy-image.png",
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticStyle: {
        "line-height": "0.8"
      }
    }, [_c('p', [_vm._v(_vm._s(gallery.gallery_posts_group_name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(gallery.gallery_posts_group_posts.length) + " posts")])])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })])])])])])
  }))]), _vm._v(" "), (_vm.galleria.length == 0) ? _c('div', {
    staticStyle: {
      "margin": "1em"
    }
  }, [_vm._m(27)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e(), _vm._v(" "), (_vm.component_view.viewLookbook) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('button', {
    staticClass: "btn admin-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponentView('lookbooks', '', 'viewLookbooks')
      }
    }
  }, [_vm._v("<< Back ")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row col-md-12",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', {
    staticClass: "col-md-5 col-xs-12"
  }, [_c('div', {
    staticClass: "product-detail-card"
  }, [_c('div', [_c('h4', [_vm._v(_vm._s(_vm.lookbook.gallery_posts_group_name))]), _vm._v(" "), (_vm.lookbook.gallery_posts_group_type == 1) ? _c('p', [_vm._v("Type: Posts Lookbook")]) : _vm._e(), _vm._v(" "), (_vm.lookbook.gallery_posts_group_type == 2) ? _c('p', [_vm._v("Type: Product Lookbook")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "white-space": "pre-line"
    }
  }, [_vm._v("Description: " + _vm._s(_vm.lookbook.gallery_posts_group_text))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "float": "right"
    }
  }, [_c('div', [_c('button', {
    staticClass: "btn admin-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setLookbookComponent('editLookbook', 'lookbook', _vm.lookbook)
      }
    }
  }, [_vm._v("Edit Lookbook ")]), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setLookbookComponent('deleteLookbook', 'lookbook', _vm.lookbook)
      }
    }
  }, [_vm._v("Delete ")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]), _vm._v(" "), (_vm.lookbook_details.editLookbook) ? _c('div', {
    staticClass: "row col-md-12"
  }, [_c('h6', [_vm._v("Edit Lookbook")]), _vm._v(" "), _c('form', {
    staticClass: "sp-forms-one"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('label', [_vm._v(" Lookbook Name\r\n                            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lookbook.gallery_posts_group_name),
      expression: "lookbook.gallery_posts_group_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.lookbook.gallery_posts_group_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lookbook.gallery_posts_group_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('label', [_vm._v(" Details ")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lookbook.gallery_posts_group_text),
      expression: "lookbook.gallery_posts_group_text"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "100%",
      "height": "250px"
    },
    domProps: {
      "value": (_vm.lookbook.gallery_posts_group_text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lookbook.gallery_posts_group_text = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn col-md-4",
    staticStyle: {
      "line-height": "1.2",
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.editLookbook
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn col-md-4",
    staticStyle: {
      "line-height": "1.2",
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Cancel")])])])])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.lookbook_details.deleteLookbook) ? _c('div', {
    staticClass: "row col-md-12"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Do you really want to delete this Lookbook?")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs admin-btn-tiny",
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": _vm.deleteLookbook
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs admin-btn-tiny",
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])]) : _vm._e(), _vm._v(" "), _c('hr')])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7 col-xs-12"
  }, [_c('div', {
    staticClass: "row product-detail-card"
  }, [_c('h5', {
    staticClass: "col-md-12"
  }, [_vm._v("Posts in Lookbook")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._l((_vm.lookbook.gallery_posts_group_posts), function(post, pndex) {
    return _c('div', {
      staticClass: "col-md-4 col-xs-4"
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setComponentView('lookbooks', post, 'viewLookbookPost')
        }
      }
    }, [_c('div', {
      staticClass: "info-card info-card-lookbook"
    }, [_c('div', {
      staticClass: "container info-card-body"
    }, [_c('div', {
      staticClass: "info-card-row info-card-lookbook-row"
    }, [_c('div', {}, [(post.gallery_post_media && (post.gallery_post_media.length > 0)) ? _c('div', {
      staticClass: "info-card-lookbook-image",
      staticStyle: {
        "margin": "5px"
      }
    }, [(_vm.checkIfVideo(post.gallery_post_media[0].gallery_post_media)) ? _c('img', {
      staticClass: "sp-prd-img-cs",
      attrs: {
        "src": "/static/assets/images/video-placeholder.png"
      }
    }) : _c('img', {
      staticClass: "sp-prd-img-cs",
      attrs: {
        "src": post.gallery_post_media[0].gallery_post_media
      }
    })]) : _c('div', {
      staticStyle: {
        "margin": "5px"
      }
    }, [_c('img', {
      staticClass: "sp-prd-img-cs",
      attrs: {
        "src": "/static/assets/images/dummy-image.png",
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticStyle: {
        "line-height": "0.8"
      }
    }, [_c('p', [_vm._v(_vm._s(post.gallery_post_caption))])])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })])])])])])
  }), _vm._v(" "), (_vm.lookbook.gallery_posts_group_posts.length == 0) ? _c('div', {
    staticStyle: {
      "margin": "1em"
    }
  }, [_vm._m(28)]) : _vm._e()], 2)])])]) : _vm._e(), _vm._v(" "), (_vm.component_view.viewLookbookPost) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('button', {
    staticClass: "btn admin-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponentView('lookbooks', _vm.lookbook, 'viewLookbook')
      }
    }
  }, [_vm._v("<< Back ")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row col-md-12",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('div', {
    staticClass: "product-detail-card"
  }, [_c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "float": "right"
    }
  }, [(_vm.lookbook.gallery_posts_group_type == 1) ? _c('div', [_c('button', {
    staticClass: "btn admin-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setLookbookComponent('editLookbookPost', 'postlookbook', _vm.lookbook_post)
      }
    }
  }, [_vm._v("Edit Post ")]), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setLookbookComponent('deleteLookbookPost', 'postlookbook', _vm.lookbook_post)
      }
    }
  }, [_vm._v("Delete Post ")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e(), _vm._v(" "), (_vm.lookbook.gallery_posts_group_type == 2) ? _c('div', [_c('button', {
    staticClass: "btn admin-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setLookbookComponent('viewProductLookbookPost', 'productlookbook', _vm.lookbook_post)
      }
    }
  }, [_vm._v("Edit Product Post")]), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setLookbookComponent('deleteLookbookPost', 'postlookbook', _vm.lookbook_post)
      }
    }
  }, [_vm._v("Delete Product Post ")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h4', [_vm._v(_vm._s(_vm.lookbook_post.gallery_post_caption))]), _vm._v(" "), _c('p', [_vm._v("Description: " + _vm._s(_vm.lookbook_post.gallery_post_details))]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.lookbook_details.editLookbookPost) ? _c('div', {
    staticClass: "row col-md-12"
  }, [_c('h6', [_vm._v("Edit Post")]), _vm._v(" "), _c('form', {
    staticClass: "sp-forms-one"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('label', [_vm._v(" *Post Caption\r\n                            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lookbook_post.gallery_post_caption),
      expression: "lookbook_post.gallery_post_caption"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.lookbook_post.gallery_post_caption)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lookbook_post.gallery_post_caption = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('label', [_vm._v(" *Post Details\r\n                            "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lookbook_post.gallery_post_details),
      expression: "lookbook_post.gallery_post_details"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.lookbook_post.gallery_post_details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lookbook_post.gallery_post_details = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn col-md-4",
    staticStyle: {
      "line-height": "1.2",
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.editLookbookPost
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn col-md-4",
    staticStyle: {
      "line-height": "1.2",
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Cancel")])])])])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.lookbook_details.deleteLookbookPost) ? _c('div', {
    staticClass: "row col-md-12"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Do you really want to delete this Post?")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs admin-btn-tiny",
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": _vm.deleteLookbookPost
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs admin-btn-tiny",
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h6', [_vm._v("Post Images")]), _vm._v(" "), ((_vm.lookbook_post.gallery_post_media) && (_vm.lookbook_post.gallery_post_media.length > 0)) ? _c('div', {
    staticClass: "row img-row",
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_vm._l((_vm.lookbook_post.gallery_post_media), function(pm) {
    return _c('div', {
      staticClass: "col-xs-12",
      staticStyle: {
        "padding": "0",
        "border": "#eeccee 1px solid"
      }
    }, [_c('div', {
      staticClass: "img-row"
    }, [(_vm.lookbook_post.gallery_post_media && (_vm.lookbook_post.gallery_post_media.length > 0)) ? _c('div', {
      staticClass: "img-column",
      staticStyle: {
        "margin": "5px"
      }
    }, [_c('div', {
      staticClass: "col-xs-8",
      staticStyle: {
        "z-index": "1"
      }
    }, [(_vm.checkIfVideo(pm.gallery_post_media)) ? _c('div', [_c('img', {
      staticClass: "sp-prd-img",
      staticStyle: {
        "z-index": "1",
        "height": "50px",
        "width": "80px"
      },
      attrs: {
        "src": "/static/assets/images/video-placeholder.png"
      }
    })]) : _c('div', [((pm.gallery_post_media && (pm.gallery_post_media != 'error'))) ? _c('img', {
      staticClass: "img-1 sp-prd-img",
      staticStyle: {
        "z-index": "1",
        "height": "50px",
        "width": "80px"
      },
      attrs: {
        "src": pm.gallery_post_media
      }
    }) : _c('img', {
      staticStyle: {
        "z-index": "1",
        "height": "50px",
        "width": "80px"
      },
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]), _vm._v(" "), (_vm.lookbook.gallery_posts_group_type == 1) ? _c('a', {
      staticClass: "col-xs-2 btn pull-right",
      staticStyle: {
        "z-index": "9",
        "margin-top": "4em",
        "font-size": "10px",
        "padding": "6px"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.deletePostImage(pm.gallery_post_media_id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })]) : _vm._e()]) : _vm._e()])])
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 2) : _vm._e(), _vm._v(" "), (_vm.lookbook.gallery_posts_group_type == 1) ? _c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "upload-btn",
    staticStyle: {
      "line-height": "0.6",
      "font-size": "12px"
    }
  }, [_vm._v("Add new Media")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*,video/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChangeLookbook($event, 'gallery_media', _vm.lookbook_post.gallery_post_id)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('hr')])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-xs-12"
  }, [_c('div', {
    staticClass: "row product-detail-card"
  }, [_c('h5', {
    staticClass: "col-md-12"
  }, [_vm._v("Other Posts in \r\n                  "), _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponentView('lookbooks', _vm.lookbook, 'viewLookbook')
      }
    }
  }, [_c('u', [_vm._v(_vm._s(_vm.lookbook.gallery_posts_group_name))])]), _vm._v(" Lookbook")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._l((_vm.lookbook.gallery_posts_group_posts), function(post, pndex) {
    return _c('div', {
      staticClass: "col-md-6 col-xs-6"
    }, [(post.gallery_post_id != _vm.lookbook_post.gallery_post_id) ? _c('div', [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setComponentView('lookbooks', post, 'viewLookbookPost')
        }
      }
    }, [_c('div', {
      staticClass: "info-card info-card-lookbook"
    }, [_c('div', {
      staticClass: "container info-card-body"
    }, [_c('div', {
      staticClass: "info-card-row info-card-lookbook-row"
    }, [_c('div', {}, [(post.gallery_post_media && (post.gallery_post_media.length > 0)) ? _c('div', {
      staticClass: "info-card-lookbook-image",
      staticStyle: {
        "margin": "5px"
      }
    }, [(_vm.checkIfVideo(post.gallery_post_media[0].gallery_post_media)) ? _c('img', {
      staticClass: "sp-prd-img-cs",
      attrs: {
        "src": "/static/assets/images/video-placeholder.png"
      }
    }) : _c('img', {
      staticClass: "sp-prd-img-cs",
      attrs: {
        "src": post.gallery_post_media[0].gallery_post_media
      }
    })]) : _c('div', {
      staticStyle: {
        "margin": "5px"
      }
    }, [_c('img', {
      staticClass: "sp-prd-img-cs",
      attrs: {
        "src": "/static/assets/images/dummy-image.png",
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticStyle: {
        "line-height": "0.8"
      }
    }, [_c('p', [_vm._v(_vm._s(post.gallery_post_caption))])])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })])])])])]) : _vm._e()])
  }), _vm._v(" "), (_vm.lookbook.gallery_posts_group_posts && (_vm.lookbook.gallery_posts_group_posts.length == 0)) ? _c('div', {
    staticStyle: {
      "margin": "1em"
    }
  }, [_vm._m(29)]) : _vm._e()], 2)])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.managePosts) ? _c('div', {
    staticClass: "container"
  }) : _vm._e(), _vm._v(" "), (_vm.manageOrders) ? _c('div', {
    staticClass: "container"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo-box clearfix"
  }, [_c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/logo.png",
      "alt": "Gallery"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "menu-toggler",
    attrs: {
      "data-target": "#main-nav-bar"
    }
  }, [_c('span', {
    staticClass: "fa fa-bars"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "loading-md"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('i', {
    staticClass: "fa fa-briefcase info-profile"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-card-header"
  }, [_c('h5', [_vm._v("Lookbooks")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Your Gallery is empty, click on "), _c('b', [_vm._v("Manage")]), _vm._v(" to add Lookbooks to your gallery")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-card-header"
  }, [_c('div', {
    staticClass: "row info-card-inner-row"
  }, [_c('h5', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('i', {
    staticClass: "fa fa-bell"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', {
    staticClass: "slide-0",
    staticStyle: {
      "display": "none"
    }
  }), _vm._v(" "), _c('li', {
    staticClass: "slide-1",
    staticStyle: {
      "display": "none"
    }
  }), _vm._v(" "), _c('li', {
    staticClass: "slide-2",
    staticStyle: {
      "display": "none"
    }
  }), _vm._v(" "), _c('li', {
    staticClass: "slide-3",
    staticStyle: {
      "display": "none"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "slide-2"
  }, [_c('p', {
    staticClass: "text-slide"
  }, [_vm._v("We hope you love your lookbook Gallery")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "slide-3"
  }, [_c('p', {
    staticClass: "text-slide"
  }, [_vm._v("Welcome to your lookbook Gallery")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pc-slider-arrow-prev"
  }, [_c('label', {
    staticClass: "slide-0",
    attrs: {
      "for": "input-slide-0"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "slide-1",
    attrs: {
      "for": "input-slide-1"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "slide-2",
    attrs: {
      "for": "input-slide-2"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "slide-3",
    attrs: {
      "for": "input-slide-3"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pc-slider-arrow-next"
  }, [_c('label', {
    staticClass: "slide-0",
    attrs: {
      "for": "input-slide-0"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "slide-1",
    attrs: {
      "for": "input-slide-1"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "slide-2",
    attrs: {
      "for": "input-slide-2"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "slide-3",
    attrs: {
      "for": "input-slide-3"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pc-slider-dot"
  }, [_c('label', {
    staticClass: "slide-0",
    attrs: {
      "for": "input-slide-0"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "slide-1",
    attrs: {
      "for": "input-slide-1"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "slide-2",
    attrs: {
      "for": "input-slide-2"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "slide-3",
    attrs: {
      "for": "input-slide-3"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notification-slide"
  }, [_c('div', {
    staticClass: "pc-slider"
  }, [_c('input', {
    staticClass: "input-slide input-slide-num",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "name": "input-slider",
      "id": "input-slide-0",
      "type": "radio"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "input-slide input-slide-num",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "name": "input-slider",
      "id": "input-slide-1",
      "type": "radio"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "input-slide input-slide-num",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "name": "input-slider",
      "id": "input-slide-2",
      "type": "radio"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "input-slide input-slide-num",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "name": "input-slider",
      "id": "input-slide-3",
      "type": "radio"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "input-slide",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "name": "input-slider",
      "id": "input-slide-autoplay",
      "type": "radio",
      "checked": ""
    }
  }), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "slide-0",
    staticStyle: {
      "display": "none"
    }
  }), _vm._v(" "), _c('li', {
    staticClass: "slide-1",
    staticStyle: {
      "display": "none"
    }
  }), _vm._v(" "), _c('li', {
    staticClass: "slide-2",
    staticStyle: {
      "display": "none"
    }
  }), _vm._v(" "), _c('li', {
    staticClass: "slide-3",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "slide-description"
  }, [_c('label', {
    staticClass: "slide-0"
  }, [_c('p', {
    staticClass: "text-slide"
  }, [_vm._v("If you have any issues setting up your Gallery Lookbooks, please do not hesitate to contact support")])]), _vm._v(" "), _c('label', {
    staticClass: "slide-1"
  }, [_c('p', {
    staticClass: "text-slide"
  }, [_vm._v("Upgrade or Customize your account to unlock more features")])]), _vm._v(" "), _c('label', {
    staticClass: "slide-2"
  }, [_c('p', {
    staticClass: "text-slide"
  }, [_vm._v("We hope you love your lookbook Gallery")])]), _vm._v(" "), _c('label', {
    staticClass: "slide-3"
  }, [_c('p', {
    staticClass: "text-slide"
  }, [_vm._v("Welcome to your lookbook Gallery")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "pc-slider-arrow-prev"
  }, [_c('label', {
    staticClass: "slide-0",
    attrs: {
      "for": "input-slide-0"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "slide-1",
    attrs: {
      "for": "input-slide-1"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "slide-2",
    attrs: {
      "for": "input-slide-2"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "slide-3",
    attrs: {
      "for": "input-slide-3"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pc-slider-arrow-next"
  }, [_c('label', {
    staticClass: "slide-0",
    attrs: {
      "for": "input-slide-0"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "slide-1",
    attrs: {
      "for": "input-slide-1"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "slide-2",
    attrs: {
      "for": "input-slide-2"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "slide-3",
    attrs: {
      "for": "input-slide-3"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pc-slider-dot"
  }, [_c('label', {
    staticClass: "slide-0",
    attrs: {
      "for": "input-slide-0"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "slide-1",
    attrs: {
      "for": "input-slide-1"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "slide-2",
    attrs: {
      "for": "input-slide-2"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "slide-3",
    attrs: {
      "for": "input-slide-3"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-card-header"
  }, [_c('div', {
    staticClass: "row info-card-inner-row"
  }, [_c('h5', [_vm._v("CONTACT DETAILS")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-card-header"
  }, [_c('div', {
    staticClass: "row info-card-inner-row"
  }, [_c('h5', [_vm._v("SUBSCRIPTION STATUS")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 col-sm-12",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [_c('div', {
    staticClass: "manage-action-block"
  }, [_c('h5', [_vm._v("Your Subscription is Active ")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "inherit"
    }
  }, [_c('p', [_vm._v("Would you love to Customize your Gallery? "), _c('a', {
    staticClass: "btn",
    staticStyle: {
      "background": "#ff0055",
      "color": "#ffffff"
    },
    attrs: {
      "href": "/customize"
    }
  }, [_vm._v("Talk to your Web Gallery Assistant")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-card-header"
  }, [_c('div', {
    staticClass: "row info-card-inner-row"
  }, [_c('h5', [_vm._v("SETTINGS")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row info-card-inner-row"
  }, [_c('a', {
    staticClass: "btn",
    staticStyle: {
      "cursor": "pointer",
      "background": "#f1dee4",
      "padding": "1em",
      "color": "#000"
    },
    attrs: {
      "href": "login"
    }
  }, [_vm._v("Logout from Account")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col",
    staticStyle: {
      "margin-top": "5em",
      "margin-bottom": "5em"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "loading-md"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-card info-card-mini"
  }, [_c('div', {
    staticClass: "info-card-header"
  }, [_c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "container info-card-body"
  }, [_c('div', {
    staticClass: "info-card-row info-card-mini-row"
  }, [_c('p', [_vm._v("View and Update Business Details")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-card info-card-mini"
  }, [_c('div', {
    staticClass: "info-card-header"
  }, [_c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "container info-card-body"
  }, [_c('div', {
    staticClass: "info-card-row info-card-mini-row"
  }, [_c('p', [_vm._v("Set Business Delivery and Shipping Information")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-card info-card-mini"
  }, [_c('div', {
    staticClass: "info-card-header"
  }, [_c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "container info-card-body"
  }, [_c('div', {
    staticClass: "info-card-row info-card-mini-row"
  }, [_c('p', [_vm._v("Set Business Coupons and Vouchers")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-card info-card-mini"
  }, [_c('div', {
    staticClass: "info-card-header"
  }, [_c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "container info-card-body"
  }, [_c('div', {
    staticClass: "info-card-row info-card-mini-row"
  }, [_c('p', [_vm._v("Connect to your Business Payment Receival Portal")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h6', [_vm._v("Your Sellpoint's Delivery Information")]), _vm._v(" "), _c('p', {
    staticClass: "p-tiny",
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("This is the general shipping Information that would be shown to buyers")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('p', {
    staticStyle: {
      "color": "#363535",
      "font-size": "14px"
    }
  }, [_vm._v("Note that you can only set one Sellpoint Discount at a time.\r\n                                If you want to end an existing discount click on \"Stop Discount\" button near the\r\n                                button.\r\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#363535",
      "line-height": "1.2"
    }
  }, [_vm._v("Note that you can only set one Sellpoint Discount at a time.\r\n                          If you want to end an existing discount click on \"Stop Discount\" button on the Discount.\r\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Your Gallery is empty, click on "), _c('b', [_vm._v("Manage")]), _vm._v(" to add Lookbooks to your gallery")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("This Lookbook is empty, click on "), _c('b', [_vm._v("Manage")]), _vm._v(" to add Posts to your lookbook")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("This Lookbook is empty, click on "), _c('b', [_vm._v("Manage")]), _vm._v(" to add Posts to your lookbook")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3897d0b1"}!./src/pages/Buypoint/template.html
// module id = 288
// module chunks = 0